import { jsx as s, jsxs as E, Fragment as q } from "react/jsx-runtime";
import { AlertGroup as Jr, Alert as Lr, AlertVariant as nt, AlertActionCloseButton as Hr, Page as Ur, Modal as zt, ModalVariant as Fr, Button as L, TextContent as $r, Text as st, FormHelperText as ft, HelperText as mt, HelperTextItem as yt, Popover as jr, Icon as ot, FormGroup as Yt, NumberInput as Vr, ValidatedOptions as X, InputGroup as Ue, InputGroupItem as at, TextInput as Fe, Select as $e, MenuToggle as ve, MenuToggleStatus as gt, SelectList as je, SelectOption as bt, TextInputGroup as Xt, TextInputGroupMain as Zt, ChipGroup as St, Chip as wt, TextInputGroupUtilities as Qt, Switch as Br, TextArea as er, Title as qr, Card as Gr, CardHeader as zr, CardTitle as Yr, CardBody as Xr, Grid as Zr, GridItem as Nt, PageSection as Qr, JumpLinks as en, JumpLinksItem as tn, ButtonVariant as We, Checkbox as rn, Radio as nn, MenuFooter as sn, Dropdown as on, DropdownList as an, DropdownItem as Wt, Masthead as cn, MastheadToggle as ln, PageToggleButton as dn, MastheadBrand as un, MastheadContent as hn, Toolbar as Ne, ToolbarContent as it, ToolbarItem as B, Avatar as pn, Bullseye as fn, Spinner as mn, EmptyState as yn, EmptyStateIcon as Mt, EmptyStateHeader as gn, EmptyStateBody as bn, EmptyStateFooter as Sn, EmptyStateActions as wn, SearchInput as En, Divider as Cn, Pagination as Tn, Badge as vn } from "@patternfly/react-core";
import { createContext as tr, useContext as rr, useRef as Z, useEffect as ye, useCallback as Te, useState as _, useMemo as H, forwardRef as In, useId as nr, Fragment as sr, Children as or, Component as An, isValidElement as _n } from "react";
import { useTranslation as U } from "react-i18next";
import { NetworkError as ar } from "@keycloak/keycloak-admin-client";
import kn from "keycloak-js";
import { ExclamationCircleIcon as Rn, HelpIcon as Jt, EyeIcon as Pn, EyeSlashIcon as xn, TimesIcon as ir, CubeIcon as On, PaypalIcon as Dn, InstagramIcon as Kn, BitbucketIcon as Nn, MicrosoftIcon as Wn, TwitterIcon as Mn, StackOverflowIcon as Jn, OpenshiftIcon as Ln, LinkedinIcon as Hn, GoogleIcon as Un, GitlabIcon as Fn, FacebookSquareIcon as $n, GithubIcon as jn, MinusCircleIcon as Vn, PlusCircleIcon as cr, EllipsisVIcon as Bn, BarsIcon as qn, SearchIcon as Gn, SyncAltIcon as zn } from "@patternfly/react-icons";
import { useFormContext as Ve, Controller as ge, useController as Et, FormProvider as Yn, useWatch as Xn } from "react-hook-form";
import { get as J, intersectionBy as Zn, cloneDeep as Qn } from "lodash-es";
import xe from "@patternfly/react-styles/css/components/Avatar/avatar";
import { css as es } from "@patternfly/react-styles";
import { Table as ts, TableVariant as rs, Thead as ns, Tr as Oe, Th as Ze, Tbody as Lt, Td as fe, ExpandableRowContent as ss, ActionsColumn as os, TableText as as } from "@patternfly/react-table";
import './main.css';function Ct(e, t) {
  const r = tr(t);
  return r.displayName = e, r;
}
const is = ["error", "errorMessage"], Qe = "error_description";
function cs(e) {
  if (typeof e == "string")
    return e;
  if (e instanceof ar)
    return ds(e.responseData);
  if (e instanceof Error)
    return e.message;
  throw new Error("Unable to determine error message.");
}
function ls(e) {
  if (!(e instanceof ar))
    return;
  const t = e.responseData;
  return lr(t);
}
function lr(e) {
  if (typeof e == "object" && e !== null && Qe in e && typeof e[Qe] == "string")
    return e[Qe];
}
function ds(e) {
  if (!(typeof e != "object" || e === null))
    for (const t of is) {
      const r = e[t];
      if (typeof r == "string")
        return r;
    }
}
const us = () => Math.floor(Math.random() * 1e3);
function hs(e) {
  return e != null;
}
function Tt(e) {
  const t = rr(e);
  if (hs(t))
    return t;
  throw new Error(
    `No provider found for ${e.displayName ? `the '${e.displayName}'` : "an unknown"} context, make sure it is included in your component hierarchy.`
  );
}
function ps() {
  const e = Z(!1), t = Z(/* @__PURE__ */ new Set());
  ye(() => (e.current = !1, () => {
    e.current = !0, r();
  }), []);
  function r() {
    t.current.forEach((n) => clearTimeout(n)), t.current.clear();
  }
  return Te((n, o) => {
    if (e.current)
      throw new Error("Can't schedule a timeout on an unmounted component.");
    const a = Number(setTimeout(i, o));
    t.current.add(a);
    function i() {
      t.current.delete(a), n();
    }
    return function() {
      clearTimeout(a), t.current.delete(a);
    };
  }, []);
}
function fs({ alerts: e, onCloseAlert: t }) {
  return /* @__PURE__ */ s(
    Jr,
    {
      "data-testid": "global-alerts",
      isToast: !0,
      style: { whiteSpace: "pre-wrap" },
      children: e.map(({ id: r, variant: n, message: o, description: a }, i) => /* @__PURE__ */ s(
        Lr,
        {
          "data-testid": i === 0 ? "last-alert" : void 0,
          isLiveRegion: !0,
          variant: nt[n],
          component: "p",
          variantLabel: "",
          title: o,
          actionClose: /* @__PURE__ */ s(
            Hr,
            {
              title: o,
              onClose: () => t(r)
            }
          ),
          children: a && /* @__PURE__ */ s("p", { children: a })
        },
        r
      ))
    }
  );
}
const ms = 8e3, dr = Ct(
  "AlertContext",
  void 0
), ya = () => Tt(dr), ys = ({ children: e }) => {
  const { t } = U(), r = ps(), [n, o] = _([]), a = (d) => o((p) => p.filter((u) => u.id !== d)), i = Te(
    (d, p = nt.success, u) => {
      const y = {
        id: us(),
        message: d,
        variant: p,
        description: u
      };
      o((f) => [y, ...f]), r(() => a(y.id), ms);
    },
    [r]
  ), c = Te(
    (d, p) => {
      const u = t(d, { error: cs(p) }), y = ls(p);
      i(u, nt.danger, y);
    },
    [i, t]
  ), l = H(() => ({ addAlert: i, addError: c }), [i, c]);
  return /* @__PURE__ */ E(dr.Provider, { value: l, children: [
    /* @__PURE__ */ s(fs, { alerts: n, onCloseAlert: a }),
    e
  ] });
}, gs = (e) => {
  const { t } = U(), r = e.error, n = bs(r) || lr(r)?.replace(/\+/g, " ");
  console.error(r);
  function o() {
    location.href = location.origin + location.pathname;
  }
  return /* @__PURE__ */ s(Ur, { children: /* @__PURE__ */ s(
    zt,
    {
      variant: Fr.small,
      title: n ? "" : t("somethingWentWrong"),
      titleIconVariant: "danger",
      showClose: !1,
      isOpen: !0,
      actions: [
        /* @__PURE__ */ s(L, { variant: "primary", onClick: o, children: t("tryAgain") }, "tryAgain")
      ],
      children: /* @__PURE__ */ s($r, { children: n ? /* @__PURE__ */ s(st, { children: t(n) }) : /* @__PURE__ */ s(st, { children: t("somethingWentWrongDescription") }) })
    }
  ) });
};
function bs(e) {
  return typeof e == "string" ? e : e instanceof Error ? e.message : null;
}
function Ss(e, t, r) {
  const [n, o] = _(
    () => e.getItem(t) ?? r
  ), a = Te((i) => {
    o(i), e.setItem(t, i);
  }, []);
  return ye(() => {
    o(e.getItem(t) ?? r), window.addEventListener("storage", i);
    function i(c) {
      c.storageArea === e && (c.key === null || c.key === t) && o(c.newValue ?? r);
    }
    return () => window.removeEventListener("storage", i);
  }, [e, t]), [n, a];
}
function ur(e, t, r) {
  const n = H(
    () => JSON.stringify(r),
    [r]
  ), [o, a] = Ss(
    e,
    t,
    n
  ), i = H(() => JSON.parse(o), [o]), c = Te(
    (l) => a(JSON.stringify(l)),
    []
  );
  return [i, c];
}
const hr = Ct(
  "HelpContext",
  void 0
), ws = () => Tt(hr), Es = ({ children: e }) => {
  const [t, r] = ur(localStorage, "helpEnabled", !0);
  function n() {
    r(!t);
  }
  return /* @__PURE__ */ s(hr.Provider, { value: { enabled: t, toggleHelp: n }, children: e });
}, Cs = ({ wrapperClassName: e = "" }) => /* @__PURE__ */ s("div", { ...e ? { className: e } : {}, children: /* @__PURE__ */ s("div", { className: "spinner" }) }), vt = crypto, pr = (e) => e instanceof CryptoKey, me = new TextEncoder(), Me = new TextDecoder();
function Ts(...e) {
  const t = e.reduce((o, { length: a }) => o + a, 0), r = new Uint8Array(t);
  let n = 0;
  for (const o of e)
    r.set(o, n), n += o.length;
  return r;
}
const vs = (e) => {
  let t = e;
  typeof t == "string" && (t = me.encode(t));
  const r = 32768, n = [];
  for (let o = 0; o < t.length; o += r)
    n.push(String.fromCharCode.apply(null, t.subarray(o, o + r)));
  return btoa(n.join(""));
}, et = (e) => vs(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_"), Is = (e) => {
  const t = atob(e), r = new Uint8Array(t.length);
  for (let n = 0; n < t.length; n++)
    r[n] = t.charCodeAt(n);
  return r;
}, Be = (e) => {
  let t = e;
  t instanceof Uint8Array && (t = Me.decode(t)), t = t.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
  try {
    return Is(t);
  } catch {
    throw new TypeError("The input to be decoded is not correctly encoded.");
  }
};
class W extends Error {
  constructor(t, r) {
    super(t, r), this.code = "ERR_JOSE_GENERIC", this.name = this.constructor.name, Error.captureStackTrace?.(this, this.constructor);
  }
}
W.code = "ERR_JOSE_GENERIC";
class As extends W {
  constructor(t, r, n = "unspecified", o = "unspecified") {
    super(t, { cause: { claim: n, reason: o, payload: r } }), this.code = "ERR_JWT_CLAIM_VALIDATION_FAILED", this.claim = n, this.reason = o, this.payload = r;
  }
}
As.code = "ERR_JWT_CLAIM_VALIDATION_FAILED";
class _s extends W {
  constructor(t, r, n = "unspecified", o = "unspecified") {
    super(t, { cause: { claim: n, reason: o, payload: r } }), this.code = "ERR_JWT_EXPIRED", this.claim = n, this.reason = o, this.payload = r;
  }
}
_s.code = "ERR_JWT_EXPIRED";
class ks extends W {
  constructor() {
    super(...arguments), this.code = "ERR_JOSE_ALG_NOT_ALLOWED";
  }
}
ks.code = "ERR_JOSE_ALG_NOT_ALLOWED";
class se extends W {
  constructor() {
    super(...arguments), this.code = "ERR_JOSE_NOT_SUPPORTED";
  }
}
se.code = "ERR_JOSE_NOT_SUPPORTED";
class Rs extends W {
  constructor(t = "decryption operation failed", r) {
    super(t, r), this.code = "ERR_JWE_DECRYPTION_FAILED";
  }
}
Rs.code = "ERR_JWE_DECRYPTION_FAILED";
class Ps extends W {
  constructor() {
    super(...arguments), this.code = "ERR_JWE_INVALID";
  }
}
Ps.code = "ERR_JWE_INVALID";
class he extends W {
  constructor() {
    super(...arguments), this.code = "ERR_JWS_INVALID";
  }
}
he.code = "ERR_JWS_INVALID";
class V extends W {
  constructor() {
    super(...arguments), this.code = "ERR_JWT_INVALID";
  }
}
V.code = "ERR_JWT_INVALID";
class xs extends W {
  constructor() {
    super(...arguments), this.code = "ERR_JWK_INVALID";
  }
}
xs.code = "ERR_JWK_INVALID";
class Os extends W {
  constructor() {
    super(...arguments), this.code = "ERR_JWKS_INVALID";
  }
}
Os.code = "ERR_JWKS_INVALID";
class Ds extends W {
  constructor(t = "no applicable key found in the JSON Web Key Set", r) {
    super(t, r), this.code = "ERR_JWKS_NO_MATCHING_KEY";
  }
}
Ds.code = "ERR_JWKS_NO_MATCHING_KEY";
class Ks extends W {
  constructor(t = "multiple matching keys found in the JSON Web Key Set", r) {
    super(t, r), this.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
  }
}
Ks.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
class Ns extends W {
  constructor(t = "request timed out", r) {
    super(t, r), this.code = "ERR_JWKS_TIMEOUT";
  }
}
Ns.code = "ERR_JWKS_TIMEOUT";
class Ws extends W {
  constructor(t = "signature verification failed", r) {
    super(t, r), this.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
  }
}
Ws.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
function F(e, t = "algorithm.name") {
  return new TypeError(`CryptoKey does not support this operation, its ${t} must be ${e}`);
}
function we(e, t) {
  return e.name === t;
}
function tt(e) {
  return parseInt(e.name.slice(4), 10);
}
function Ms(e) {
  switch (e) {
    case "ES256":
      return "P-256";
    case "ES384":
      return "P-384";
    case "ES512":
      return "P-521";
    default:
      throw new Error("unreachable");
  }
}
function Js(e, t) {
  if (t.length && !t.some((r) => e.usages.includes(r))) {
    let r = "CryptoKey does not support this operation, its usages must include ";
    if (t.length > 2) {
      const n = t.pop();
      r += `one of ${t.join(", ")}, or ${n}.`;
    } else t.length === 2 ? r += `one of ${t[0]} or ${t[1]}.` : r += `${t[0]}.`;
    throw new TypeError(r);
  }
}
function Ls(e, t, ...r) {
  switch (t) {
    case "HS256":
    case "HS384":
    case "HS512": {
      if (!we(e.algorithm, "HMAC"))
        throw F("HMAC");
      const n = parseInt(t.slice(2), 10);
      if (tt(e.algorithm.hash) !== n)
        throw F(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "RS256":
    case "RS384":
    case "RS512": {
      if (!we(e.algorithm, "RSASSA-PKCS1-v1_5"))
        throw F("RSASSA-PKCS1-v1_5");
      const n = parseInt(t.slice(2), 10);
      if (tt(e.algorithm.hash) !== n)
        throw F(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "PS256":
    case "PS384":
    case "PS512": {
      if (!we(e.algorithm, "RSA-PSS"))
        throw F("RSA-PSS");
      const n = parseInt(t.slice(2), 10);
      if (tt(e.algorithm.hash) !== n)
        throw F(`SHA-${n}`, "algorithm.hash");
      break;
    }
    case "EdDSA": {
      if (e.algorithm.name !== "Ed25519" && e.algorithm.name !== "Ed448")
        throw F("Ed25519 or Ed448");
      break;
    }
    case "Ed25519": {
      if (!we(e.algorithm, "Ed25519"))
        throw F("Ed25519");
      break;
    }
    case "ES256":
    case "ES384":
    case "ES512": {
      if (!we(e.algorithm, "ECDSA"))
        throw F("ECDSA");
      const n = Ms(t);
      if (e.algorithm.namedCurve !== n)
        throw F(n, "algorithm.namedCurve");
      break;
    }
    default:
      throw new TypeError("CryptoKey does not support this operation");
  }
  Js(e, r);
}
function fr(e, t, ...r) {
  if (r = r.filter(Boolean), r.length > 2) {
    const n = r.pop();
    e += `one of type ${r.join(", ")}, or ${n}.`;
  } else r.length === 2 ? e += `one of type ${r[0]} or ${r[1]}.` : e += `of type ${r[0]}.`;
  return t == null ? e += ` Received ${t}` : typeof t == "function" && t.name ? e += ` Received function ${t.name}` : typeof t == "object" && t != null && t.constructor?.name && (e += ` Received an instance of ${t.constructor.name}`), e;
}
const Ht = (e, ...t) => fr("Key must be ", e, ...t);
function mr(e, t, ...r) {
  return fr(`Key for the ${e} algorithm must be `, t, ...r);
}
const yr = (e) => pr(e) ? !0 : e?.[Symbol.toStringTag] === "KeyObject", Je = ["CryptoKey"], Hs = (...e) => {
  const t = e.filter(Boolean);
  if (t.length === 0 || t.length === 1)
    return !0;
  let r;
  for (const n of t) {
    const o = Object.keys(n);
    if (!r || r.size === 0) {
      r = new Set(o);
      continue;
    }
    for (const a of o) {
      if (r.has(a))
        return !1;
      r.add(a);
    }
  }
  return !0;
};
function Us(e) {
  return typeof e == "object" && e !== null;
}
function It(e) {
  if (!Us(e) || Object.prototype.toString.call(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
const Fs = (e, t) => {
  if (e.startsWith("RS") || e.startsWith("PS")) {
    const { modulusLength: r } = t.algorithm;
    if (typeof r != "number" || r < 2048)
      throw new TypeError(`${e} requires key modulusLength to be 2048 bits or larger`);
  }
};
function Ie(e) {
  return It(e) && typeof e.kty == "string";
}
function $s(e) {
  return e.kty !== "oct" && typeof e.d == "string";
}
function js(e) {
  return e.kty !== "oct" && typeof e.d > "u";
}
function Vs(e) {
  return Ie(e) && e.kty === "oct" && typeof e.k == "string";
}
function Bs(e) {
  let t, r;
  switch (e.kty) {
    case "RSA": {
      switch (e.alg) {
        case "PS256":
        case "PS384":
        case "PS512":
          t = { name: "RSA-PSS", hash: `SHA-${e.alg.slice(-3)}` }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "RS256":
        case "RS384":
        case "RS512":
          t = { name: "RSASSA-PKCS1-v1_5", hash: `SHA-${e.alg.slice(-3)}` }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
          t = {
            name: "RSA-OAEP",
            hash: `SHA-${parseInt(e.alg.slice(-3), 10) || 1}`
          }, r = e.d ? ["decrypt", "unwrapKey"] : ["encrypt", "wrapKey"];
          break;
        default:
          throw new se('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "EC": {
      switch (e.alg) {
        case "ES256":
          t = { name: "ECDSA", namedCurve: "P-256" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ES384":
          t = { name: "ECDSA", namedCurve: "P-384" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ES512":
          t = { name: "ECDSA", namedCurve: "P-521" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: "ECDH", namedCurve: e.crv }, r = e.d ? ["deriveBits"] : [];
          break;
        default:
          throw new se('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    case "OKP": {
      switch (e.alg) {
        case "Ed25519":
          t = { name: "Ed25519" }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "EdDSA":
          t = { name: e.crv }, r = e.d ? ["sign"] : ["verify"];
          break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
          t = { name: e.crv }, r = e.d ? ["deriveBits"] : [];
          break;
        default:
          throw new se('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
      }
      break;
    }
    default:
      throw new se('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
  }
  return { algorithm: t, keyUsages: r };
}
const qs = async (e) => {
  if (!e.alg)
    throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
  const { algorithm: t, keyUsages: r } = Bs(e), n = [
    t,
    e.ext ?? !1,
    e.key_ops ?? r
  ], o = { ...e };
  return delete o.alg, delete o.use, vt.subtle.importKey("jwk", o, ...n);
}, gr = (e) => Be(e);
let le, de;
const br = (e) => e?.[Symbol.toStringTag] === "KeyObject", Le = async (e, t, r, n, o = !1) => {
  let a = e.get(t);
  if (a?.[n])
    return a[n];
  const i = await qs({ ...r, alg: n });
  return o && Object.freeze(t), a ? a[n] = i : e.set(t, { [n]: i }), i;
}, Gs = (e, t) => {
  if (br(e)) {
    let r = e.export({ format: "jwk" });
    return delete r.d, delete r.dp, delete r.dq, delete r.p, delete r.q, delete r.qi, r.k ? gr(r.k) : (de || (de = /* @__PURE__ */ new WeakMap()), Le(de, e, r, t));
  }
  return Ie(e) ? e.k ? Be(e.k) : (de || (de = /* @__PURE__ */ new WeakMap()), Le(de, e, e, t, !0)) : e;
}, zs = (e, t) => {
  if (br(e)) {
    let r = e.export({ format: "jwk" });
    return r.k ? gr(r.k) : (le || (le = /* @__PURE__ */ new WeakMap()), Le(le, e, r, t));
  }
  return Ie(e) ? e.k ? Be(e.k) : (le || (le = /* @__PURE__ */ new WeakMap()), Le(le, e, e, t, !0)) : e;
}, Ys = { normalizePublicKey: Gs, normalizePrivateKey: zs }, pe = (e) => e?.[Symbol.toStringTag], ct = (e, t, r) => {
  if (t.use !== void 0 && t.use !== "sig")
    throw new TypeError("Invalid key for this operation, when present its use must be sig");
  if (t.key_ops !== void 0 && t.key_ops.includes?.(r) !== !0)
    throw new TypeError(`Invalid key for this operation, when present its key_ops must include ${r}`);
  if (t.alg !== void 0 && t.alg !== e)
    throw new TypeError(`Invalid key for this operation, when present its alg must be ${e}`);
  return !0;
}, Xs = (e, t, r, n) => {
  if (!(t instanceof Uint8Array)) {
    if (n && Ie(t)) {
      if (Vs(t) && ct(e, t, r))
        return;
      throw new TypeError('JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present');
    }
    if (!yr(t))
      throw new TypeError(mr(e, t, ...Je, "Uint8Array", n ? "JSON Web Key" : null));
    if (t.type !== "secret")
      throw new TypeError(`${pe(t)} instances for symmetric algorithms must be of type "secret"`);
  }
}, Zs = (e, t, r, n) => {
  if (n && Ie(t))
    switch (r) {
      case "sign":
        if ($s(t) && ct(e, t, r))
          return;
        throw new TypeError("JSON Web Key for this operation be a private JWK");
      case "verify":
        if (js(t) && ct(e, t, r))
          return;
        throw new TypeError("JSON Web Key for this operation be a public JWK");
    }
  if (!yr(t))
    throw new TypeError(mr(e, t, ...Je, n ? "JSON Web Key" : null));
  if (t.type === "secret")
    throw new TypeError(`${pe(t)} instances for asymmetric algorithms must not be of type "secret"`);
  if (r === "sign" && t.type === "public")
    throw new TypeError(`${pe(t)} instances for asymmetric algorithm signing must be of type "private"`);
  if (r === "decrypt" && t.type === "public")
    throw new TypeError(`${pe(t)} instances for asymmetric algorithm decryption must be of type "private"`);
  if (t.algorithm && r === "verify" && t.type === "private")
    throw new TypeError(`${pe(t)} instances for asymmetric algorithm verifying must be of type "public"`);
  if (t.algorithm && r === "encrypt" && t.type === "private")
    throw new TypeError(`${pe(t)} instances for asymmetric algorithm encryption must be of type "public"`);
};
function Sr(e, t, r, n) {
  t.startsWith("HS") || t === "dir" || t.startsWith("PBES2") || /^A\d{3}(?:GCM)?KW$/.test(t) ? Xs(t, r, n, e) : Zs(t, r, n, e);
}
Sr.bind(void 0, !1);
const Qs = Sr.bind(void 0, !0);
function eo(e, t, r, n, o) {
  if (o.crit !== void 0 && n?.crit === void 0)
    throw new e('"crit" (Critical) Header Parameter MUST be integrity protected');
  if (!n || n.crit === void 0)
    return /* @__PURE__ */ new Set();
  if (!Array.isArray(n.crit) || n.crit.length === 0 || n.crit.some((i) => typeof i != "string" || i.length === 0))
    throw new e('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
  let a;
  r !== void 0 ? a = new Map([...Object.entries(r), ...t.entries()]) : a = t;
  for (const i of n.crit) {
    if (!a.has(i))
      throw new se(`Extension Header Parameter "${i}" is not recognized`);
    if (o[i] === void 0)
      throw new e(`Extension Header Parameter "${i}" is missing`);
    if (a.get(i) && n[i] === void 0)
      throw new e(`Extension Header Parameter "${i}" MUST be integrity protected`);
  }
  return new Set(n.crit);
}
function to(e, t) {
  const r = `SHA-${e.slice(-3)}`;
  switch (e) {
    case "HS256":
    case "HS384":
    case "HS512":
      return { hash: r, name: "HMAC" };
    case "PS256":
    case "PS384":
    case "PS512":
      return { hash: r, name: "RSA-PSS", saltLength: e.slice(-3) >> 3 };
    case "RS256":
    case "RS384":
    case "RS512":
      return { hash: r, name: "RSASSA-PKCS1-v1_5" };
    case "ES256":
    case "ES384":
    case "ES512":
      return { hash: r, name: "ECDSA", namedCurve: t.namedCurve };
    case "Ed25519":
      return { name: "Ed25519" };
    case "EdDSA":
      return { name: t.name };
    default:
      throw new se(`alg ${e} is not supported either by JOSE or your javascript runtime`);
  }
}
async function ro(e, t, r) {
  if (t = await Ys.normalizePrivateKey(t, e), pr(t))
    return Ls(t, e, r), t;
  if (t instanceof Uint8Array) {
    if (!e.startsWith("HS"))
      throw new TypeError(Ht(t, ...Je));
    return vt.subtle.importKey("raw", t, { hash: `SHA-${e.slice(-3)}`, name: "HMAC" }, !1, [r]);
  }
  throw new TypeError(Ht(t, ...Je, "Uint8Array", "JSON Web Key"));
}
const te = (e) => Math.floor(e.getTime() / 1e3), wr = 60, Er = wr * 60, At = Er * 24, no = At * 7, so = At * 365.25, oo = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i, rt = (e) => {
  const t = oo.exec(e);
  if (!t || t[4] && t[1])
    throw new TypeError("Invalid time period format");
  const r = parseFloat(t[2]), n = t[3].toLowerCase();
  let o;
  switch (n) {
    case "sec":
    case "secs":
    case "second":
    case "seconds":
    case "s":
      o = Math.round(r);
      break;
    case "minute":
    case "minutes":
    case "min":
    case "mins":
    case "m":
      o = Math.round(r * wr);
      break;
    case "hour":
    case "hours":
    case "hr":
    case "hrs":
    case "h":
      o = Math.round(r * Er);
      break;
    case "day":
    case "days":
    case "d":
      o = Math.round(r * At);
      break;
    case "week":
    case "weeks":
    case "w":
      o = Math.round(r * no);
      break;
    default:
      o = Math.round(r * so);
      break;
  }
  return t[1] === "-" || t[4] === "ago" ? -o : o;
}, ao = async (e, t, r) => {
  const n = await ro(e, t, "sign");
  Fs(e, n);
  const o = await vt.subtle.sign(to(e, n.algorithm), n, r);
  return new Uint8Array(o);
};
class io {
  constructor(t) {
    if (!(t instanceof Uint8Array))
      throw new TypeError("payload must be an instance of Uint8Array");
    this._payload = t;
  }
  setProtectedHeader(t) {
    if (this._protectedHeader)
      throw new TypeError("setProtectedHeader can only be called once");
    return this._protectedHeader = t, this;
  }
  setUnprotectedHeader(t) {
    if (this._unprotectedHeader)
      throw new TypeError("setUnprotectedHeader can only be called once");
    return this._unprotectedHeader = t, this;
  }
  async sign(t, r) {
    if (!this._protectedHeader && !this._unprotectedHeader)
      throw new he("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
    if (!Hs(this._protectedHeader, this._unprotectedHeader))
      throw new he("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const n = {
      ...this._protectedHeader,
      ...this._unprotectedHeader
    }, o = eo(he, /* @__PURE__ */ new Map([["b64", !0]]), r?.crit, this._protectedHeader, n);
    let a = !0;
    if (o.has("b64") && (a = this._protectedHeader.b64, typeof a != "boolean"))
      throw new he('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    const { alg: i } = n;
    if (typeof i != "string" || !i)
      throw new he('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    Qs(i, t, "sign");
    let c = this._payload;
    a && (c = me.encode(et(c)));
    let l;
    this._protectedHeader ? l = me.encode(et(JSON.stringify(this._protectedHeader))) : l = me.encode("");
    const d = Ts(l, me.encode("."), c), p = await ao(i, t, d), u = {
      signature: et(p),
      payload: ""
    };
    return a && (u.payload = Me.decode(c)), this._unprotectedHeader && (u.header = this._unprotectedHeader), this._protectedHeader && (u.protected = Me.decode(l)), u;
  }
}
class co {
  constructor(t) {
    this._flattened = new io(t);
  }
  setProtectedHeader(t) {
    return this._flattened.setProtectedHeader(t), this;
  }
  async sign(t, r) {
    const n = await this._flattened.sign(t, r);
    if (n.payload === void 0)
      throw new TypeError("use the flattened module for creating JWS with b64: false");
    return `${n.protected}.${n.payload}.${n.signature}`;
  }
}
function re(e, t) {
  if (!Number.isFinite(t))
    throw new TypeError(`Invalid ${e} input`);
  return t;
}
class lo {
  constructor(t = {}) {
    if (!It(t))
      throw new TypeError("JWT Claims Set MUST be an object");
    this._payload = t;
  }
  setIssuer(t) {
    return this._payload = { ...this._payload, iss: t }, this;
  }
  setSubject(t) {
    return this._payload = { ...this._payload, sub: t }, this;
  }
  setAudience(t) {
    return this._payload = { ...this._payload, aud: t }, this;
  }
  setJti(t) {
    return this._payload = { ...this._payload, jti: t }, this;
  }
  setNotBefore(t) {
    return typeof t == "number" ? this._payload = { ...this._payload, nbf: re("setNotBefore", t) } : t instanceof Date ? this._payload = { ...this._payload, nbf: re("setNotBefore", te(t)) } : this._payload = { ...this._payload, nbf: te(/* @__PURE__ */ new Date()) + rt(t) }, this;
  }
  setExpirationTime(t) {
    return typeof t == "number" ? this._payload = { ...this._payload, exp: re("setExpirationTime", t) } : t instanceof Date ? this._payload = { ...this._payload, exp: re("setExpirationTime", te(t)) } : this._payload = { ...this._payload, exp: te(/* @__PURE__ */ new Date()) + rt(t) }, this;
  }
  setIssuedAt(t) {
    return typeof t > "u" ? this._payload = { ...this._payload, iat: te(/* @__PURE__ */ new Date()) } : t instanceof Date ? this._payload = { ...this._payload, iat: re("setIssuedAt", te(t)) } : typeof t == "string" ? this._payload = {
      ...this._payload,
      iat: re("setIssuedAt", te(/* @__PURE__ */ new Date()) + rt(t))
    } : this._payload = { ...this._payload, iat: re("setIssuedAt", t) }, this;
  }
}
class uo extends lo {
  setProtectedHeader(t) {
    return this._protectedHeader = t, this;
  }
  async sign(t, r) {
    const n = new co(me.encode(JSON.stringify(this._payload)));
    if (n.setProtectedHeader(this._protectedHeader), Array.isArray(this._protectedHeader?.crit) && this._protectedHeader.crit.includes("b64") && this._protectedHeader.b64 === !1)
      throw new V("JWTs MUST NOT use unencoded payload");
    return n.sign(t, r);
  }
}
const ho = Be;
function po(e) {
  if (typeof e != "string")
    throw new V("JWTs must use Compact JWS serialization, JWT must be a string");
  const { 1: t, length: r } = e.split(".");
  if (r === 5)
    throw new V("Only JWTs using Compact JWS serialization can be decoded");
  if (r !== 3)
    throw new V("Invalid JWT");
  if (!t)
    throw new V("JWTs must contain a payload");
  let n;
  try {
    n = ho(t);
  } catch {
    throw new V("Failed to base64url decode the payload");
  }
  let o;
  try {
    o = JSON.parse(Me.decode(n));
  } catch {
    throw new V("Failed to parse the decoded payload as JSON");
  }
  if (!It(o))
    throw new V("Invalid JWT Claims Set");
  return o;
}
const oe = (e, t) => {
  if (typeof e != "object" || typeof t != "object") return {};
  const r = { ...e };
  for (const o in t) {
    const a = o, i = t[a], c = r[a];
    !Array.isArray(i) || c && Array.isArray(c) ? Array.isArray(i) && Array.isArray(c) ? r[a] = (n = [...c, ...i], [...new Set(n.map((l) => JSON.stringify(l)))].map((l) => JSON.parse(l))) : r[a] = typeof i != "object" || typeof c != "object" ? i : oe(c, i) : r[a] = t[a];
  }
  var n;
  return r;
}, De = ({ data: e, alg: t, expiration: r, secret: n }) => new uo({ ...e }).setProtectedHeader({ alg: t }).setExpirationTime(r).sign(new TextEncoder().encode(n)), ue = (e) => {
  const t = ((n) => po(n))(e).exp;
  if (!t) return 0;
  const r = t - Math.floor(Date.now() / 1e3);
  return r <= 0 ? 0 : r;
}, _t = { profile: { id: "51d4f6c0-40a0-49ce-b91b-516c4a4bff8a", username: "jsnow", email: "j.snow@google.com", firstName: "John", lastName: "Snow", enabled: !0, emailVerified: !0, totp: !1, createdTimestamp: 631141200 }, userInfo: {}, jwt: { alg: "HS256", expiration: "5m", secret: "cc7e0d44f" }, promises: { init: { method: "resolve", resolveCallback(e) {
  e.subject = _t.profile.id;
} } }, url: { login: "", logout: "", register: "", account: "" }, tokenParsed: { aud: "account", azp: "my-frontend-app", realm_access: { roles: ["offline_access", "uma_authorization", "default-roles"] }, resource_access: { account: { roles: ["manage-account", "manage-account-links", "view-profile"] } }, sid: "8187983f-5baf-4bd1-bfe1-fd323fddd3f7.keycloak-1-43237", sub: "subject" } }, h = { ..._t }, fo = { profile(e) {
  h.profile = { ...h.profile, ...e };
}, userInfo(e) {
  h.userInfo = { ...h.userInfo, ...e };
}, jwt(e) {
  h.jwt = { ...h.jwt, ...e };
}, url(e) {
  h.url = { ...h.url, ...e };
}, tokenParsed(e) {
  h.tokenParsed = oe(h.tokenParsed, e);
}, promises(e) {
  h.promises = oe(h.promises, e);
}, reset() {
  Object.keys(h).forEach((e) => {
    h[e] = { ..._t[e] };
  });
} };
class mo {
  token = void 0;
  tokenParsed;
  authenticated;
  refreshToken;
  subject;
  responseMode;
  responseType;
  flow;
  realmAccess;
  resourceAccess;
  refreshTokenParsed;
  idToken;
  idTokenParsed;
  timeSkew;
  loginRequired;
  authServerUrl;
  realm;
  clientId;
  redirectUri;
  sessionId;
  profile;
  userInfo;
  constructor(t) {
    typeof t == "object" && t?.realm && (this.realm = t.realm), typeof t == "object" && t?.clientId && (this.clientId = t.clientId);
  }
  tokenTimeout = null;
  clearTokenTimeout() {
    this.tokenTimeout && (clearTimeout(this.tokenTimeout), this.tokenTimeout = null);
  }
  setTokenTimeout(t) {
    this.clearTokenTimeout();
    const r = ue(t);
    this.tokenTimeout = setTimeout(() => {
      this.token = void 0, this.tokenParsed = void 0, this.authenticated = void 0, this.onTokenExpired?.();
    }, 1e3 * r);
  }
  init(t) {
    return new Promise((r, n) => {
      Promise.resolve(De({ data: h.profile, ...h.jwt })).then((o) => {
        h.promises.init?.method !== "reject" ? (this.token = o, this.authenticated = !0, this.profile = h.profile, this.userInfo = h.userInfo, this.tokenParsed = oe(h.tokenParsed, { ...h.profile, exp: ue(o) }), this.setTokenTimeout(o), "token" in t && (this.token = t.token), "refreshToken" in t && (this.refreshToken = t.refreshToken), "idToken" in t && (this.idToken = t.idToken), "timeSkew" in t && (this.timeSkew = t.timeSkew), "responseMode" in t && (this.responseMode = t.responseMode), "redirectUri" in t && (this.redirectUri = t.redirectUri), "flow" in t && (this.flow = t.flow), h.promises.init?.resolveCallback?.(this), r(!0)) : (h.promises.init?.rejectCallback?.(this), n({ error: "error", error_description: "init" }));
      }).catch((o) => {
        n(o);
      });
    });
  }
  logout(t) {
    return new Promise((r, n) => {
      h.promises.logout?.method !== "reject" ? (this.token = void 0, this.tokenParsed = void 0, this.authenticated = void 0, this.profile = void 0, this.userInfo = void 0, this.clearTokenTimeout(), t && "redirectUri" in t && (this.redirectUri = t.redirectUri), h.promises.logout?.resolveCallback?.(this), this.onAuthLogout?.(), r(void 0)) : (h.promises.logout?.rejectCallback?.(this), n(void 0));
    });
  }
  updateToken(t) {
    return new Promise((r, n) => {
      Promise.resolve(De({ data: h.profile, ...h.jwt })).then((o) => {
        h.promises.updateToken?.method !== "reject" ? (this.token = o, this.authenticated = !0, this.profile = h.profile, this.userInfo = h.userInfo, this.tokenParsed = oe(h.tokenParsed, { ...h.profile, exp: ue(o) }), this.sessionId = this.tokenParsed?.sid, this.subject = this.tokenParsed?.sub, this.realmAccess = this.tokenParsed?.realm_access, this.resourceAccess = this.tokenParsed?.resource_access, this.setTokenTimeout(o), h.promises.updateToken?.resolveCallback?.(this), this.onActionUpdate?.("success"), r(!0)) : (this.onActionUpdate?.("error"), h.promises.updateToken?.rejectCallback?.(this), n({ error: "error", error_description: "updateToken" }));
      }).catch((o) => {
        n(o);
      });
    });
  }
  login(t) {
    return new Promise((r, n) => {
      Promise.resolve(De({ data: h.profile, ...h.jwt })).then((o) => {
        h.promises.login?.method !== "reject" ? (this.token = o, this.authenticated = !0, this.profile = h.profile, this.userInfo = h.userInfo, this.tokenParsed = oe(h.tokenParsed, { ...h.profile, exp: ue(o) }), this.sessionId = this.tokenParsed?.sid, this.subject = this.tokenParsed?.sub, this.realmAccess = this.tokenParsed?.realm_access, this.resourceAccess = this.tokenParsed?.resource_access, this.setTokenTimeout(o), t && "redirectUri" in t && (this.redirectUri = t.redirectUri), h.promises.login?.resolveCallback?.(this), r(void 0)) : (h.promises.login?.rejectCallback?.(this), n(void 0));
      }).catch((o) => {
        n(o);
      });
    });
  }
  register(t) {
    return new Promise((r, n) => {
      Promise.resolve(De({ data: h.profile, ...h.jwt })).then((o) => {
        h.promises.register?.method !== "reject" ? (this.token = o, this.authenticated = !0, this.profile = h.profile, this.userInfo = h.userInfo, this.tokenParsed = oe(h.tokenParsed, { ...h.profile, exp: ue(o) }), this.sessionId = this.tokenParsed?.sid, this.subject = this.tokenParsed?.sub, this.realmAccess = this.tokenParsed?.realm_access, this.resourceAccess = this.tokenParsed?.resource_access, this.setTokenTimeout(o), t && "redirectUri" in t && (this.redirectUri = t.redirectUri), h.promises.register?.resolveCallback?.(this), r(void 0)) : (h.promises.register?.rejectCallback?.(this), n(void 0));
      }).catch((o) => {
        n(o);
      });
    });
  }
  accountManagement() {
    return new Promise((t, r) => {
      h.promises.accountManagement?.method !== "reject" ? (h.promises.accountManagement?.resolveCallback?.(this), t(void 0)) : (h.promises.accountManagement?.rejectCallback?.(this), r(void 0));
    });
  }
  loadUserProfile() {
    return new Promise((t, r) => {
      h.promises.loadUserProfile?.method !== "reject" ? (h.promises.loadUserProfile?.resolveCallback?.(this), t({ ...this.profile })) : (h.promises.loadUserProfile?.rejectCallback?.(this), r(void 0));
    });
  }
  loadUserInfo() {
    return new Promise((t, r) => {
      h.promises.loadUserInfo?.method !== "reject" ? (h.promises.loadUserInfo?.resolveCallback?.(this), t({ ...this.userInfo })) : (h.promises.loadUserInfo?.rejectCallback?.(this), r(void 0));
    });
  }
  createLoginUrl(t) {
    return h.url.login;
  }
  createLogoutUrl(t) {
    return h.url.logout;
  }
  createRegisterUrl(t) {
    return h.url.register;
  }
  createAccountUrl(t) {
    return h.url.account;
  }
  isTokenExpired(t) {
    return !this.token || (t || 0) > ue(this.token);
  }
  clearToken() {
    this.clearTokenTimeout(), this.token = void 0, this.authenticated = void 0, this.profile = void 0, this.userInfo = void 0, this.tokenParsed = void 0, this.subject = void 0, this.realmAccess = void 0, this.realmAccess = void 0, this.authenticated = !1, this.onAuthLogout?.(), this.loginRequired && this.login();
  }
  hasRealmRole(t) {
    return !!h.tokenParsed.realm_access?.roles.includes(t);
  }
  hasResourceRole(t, r) {
    const n = r || h.tokenParsed.aud;
    return !!h.tokenParsed.resource_access?.[n].roles.includes(t);
  }
  onReady(t) {
  }
  onAuthSuccess() {
  }
  onAuthError(t) {
  }
  onAuthRefreshSuccess() {
  }
  onAuthRefreshError() {
  }
  onAuthLogout() {
  }
  onTokenExpired() {
  }
  onActionUpdate(t) {
  }
}
const yo = () => tr(void 0);
let lt;
const ga = () => {
  const e = rr(lt);
  if (!e)
    throw Error(
      "no environment provider in the hierarchy make sure to add the provider"
    );
  return e;
}, ba = ({
  environment: e,
  children: t
}) => {
  lt = yo();
  const r = Z(!1), [n, o] = _(!1), [a, i] = _();
  let c = H(() => {
    let d = new mo();
    return e?.isDevMode || (d = new kn({
      url: e.serverBaseUrl,
      realm: e.realm,
      clientId: e.clientId
    })), d.onAuthLogout = () => d.login(), d;
  }, [e]);
  ye(() => {
    if (r.current)
      return;
    e?.isDevMode && fo.profile({
      username: "myUserName"
    }), c.init({
      onLoad: "check-sso",
      pkceMethod: "S256",
      responseMode: "query",
      scope: e.scope
    }).then(() => o(!0)).catch((p) => i(p)), r.current = !0;
  }, [c]);
  const l = new URLSearchParams(window.location.search);
  return a || l.get("error_description") ? /* @__PURE__ */ s(
    gs,
    {
      error: a || l.get("error_description")
    }
  ) : n ? /* @__PURE__ */ s(lt.Provider, { value: { environment: e, keycloak: c }, children: /* @__PURE__ */ s(ys, { children: /* @__PURE__ */ s(Es, { children: t }) }) }) : /* @__PURE__ */ s(Cs, {});
};
function Sa() {
  const t = document.getElementById("environment")?.textContent;
  if (typeof t != "string")
    throw new Error("Environment variables not found in the document.");
  try {
    return JSON.parse(t);
  } catch {
    throw new Error("Unable to parse environment variables as JSON.");
  }
}
const wa = ({
  modalTitle: e,
  continueLabel: t,
  cancelLabel: r,
  buttonTitle: n,
  isDisabled: o,
  buttonVariant: a,
  buttonTestRole: i,
  onContinue: c,
  component: l = L,
  children: d,
  ...p
}) => {
  const [u, y] = _(!1);
  return /* @__PURE__ */ E(q, { children: [
    /* @__PURE__ */ s(
      l,
      {
        variant: a,
        onClick: () => y(!0),
        isDisabled: o,
        "data-testrole": i,
        children: n
      }
    ),
    /* @__PURE__ */ s(
      zt,
      {
        variant: "small",
        ...p,
        title: e,
        isOpen: u,
        onClose: () => y(!1),
        actions: [
          /* @__PURE__ */ s(
            L,
            {
              id: "modal-confirm",
              variant: "primary",
              onClick: () => {
                y(!1), c();
              },
              children: t
            },
            "confirm"
          ),
          /* @__PURE__ */ s(
            L,
            {
              id: "modal-cancel",
              variant: "secondary",
              onClick: () => y(!1),
              children: r
            },
            "cancel"
          )
        ],
        children: d
      }
    )
  ] });
}, Cr = ({ message: e, ...t }) => /* @__PURE__ */ s(ft, { ...t, children: /* @__PURE__ */ s(mt, { children: /* @__PURE__ */ s(yt, { icon: /* @__PURE__ */ s(Rn, {}), variant: "error", children: e }) }) }), Tr = ({
  helpText: e,
  fieldLabelId: t,
  noVerticalAlign: r = !0,
  unWrap: n = !1
}) => {
  const { enabled: o } = ws();
  return o ? /* @__PURE__ */ s(jr, { bodyContent: e, children: /* @__PURE__ */ E(q, { children: [
    !n && /* @__PURE__ */ s(
      "button",
      {
        "data-testid": `help-label-${t}`,
        "aria-label": t,
        onClick: (a) => a.preventDefault(),
        className: "pf-v5-c-form__group-label-help",
        children: /* @__PURE__ */ s(ot, { isInline: r, children: /* @__PURE__ */ s(Jt, {}) })
      }
    ),
    n && /* @__PURE__ */ s(ot, { isInline: r, children: /* @__PURE__ */ s(Jt, {}) })
  ] }) }) : null;
};
function Ae(e) {
  if (!(typeof e > "u" || e instanceof RegExp))
    return typeof e == "object" ? e.value : e;
}
const ie = ({
  name: e,
  label: t,
  labelIcon: r,
  error: n,
  children: o,
  ...a
}) => /* @__PURE__ */ E(
  Yt,
  {
    label: t || e,
    fieldId: e,
    labelIcon: r ? /* @__PURE__ */ s(Tr, { helpText: r, fieldLabelId: e }) : void 0,
    ...a,
    children: [
      o,
      n && /* @__PURE__ */ s(Cr, { "data-testid": `${e}-helper`, message: n.message })
    ]
  }
), Ea = ({
  name: e,
  label: t,
  controller: r,
  labelIcon: n,
  ...o
}) => {
  const {
    control: a,
    formState: { errors: i }
  } = Ve();
  return /* @__PURE__ */ s(
    ie,
    {
      name: e,
      label: t,
      isRequired: r.rules?.required === !0,
      error: i[e],
      labelIcon: n,
      children: /* @__PURE__ */ s(
        ge,
        {
          ...r,
          name: e,
          control: a,
          render: ({ field: c }) => {
            const l = !!r.rules?.required, d = Ae(r.rules?.min), p = c.value ?? r.defaultValue, u = (y) => c.onChange(
              d !== void 0 ? Math.max(y, Number(d)) : y
            );
            return /* @__PURE__ */ s(
              Vr,
              {
                ...o,
                id: e,
                value: p,
                validated: i[e] ? X.error : X.default,
                required: l,
                min: Number(d),
                max: Number(r.rules?.max),
                onPlus: () => u(p + 1),
                onMinus: () => u(p - 1),
                onChange: (y) => {
                  const f = Number(y.currentTarget.value);
                  u(isNaN(f) ? r.defaultValue : f);
                }
              }
            );
          }
        }
      )
    }
  );
}, go = ({
  hasReveal: e = !0,
  innerRef: t,
  ...r
}) => {
  const { t: n } = U(), [o, a] = _(!0);
  return /* @__PURE__ */ E(Ue, { children: [
    /* @__PURE__ */ s(at, { isFill: !0, children: /* @__PURE__ */ s(
      Fe,
      {
        ...r,
        type: o ? "password" : "text",
        ref: t
      }
    ) }),
    e && /* @__PURE__ */ s(
      L,
      {
        variant: "control",
        "aria-label": n("showPassword"),
        onClick: () => a(!o),
        children: o ? /* @__PURE__ */ s(Pn, {}) : /* @__PURE__ */ s(xn, {})
      }
    )
  ] });
}, vr = In(
  (e, t) => /* @__PURE__ */ s(go, { ...e, innerRef: t })
);
vr.displayName = "PasswordInput";
const Ca = (e) => {
  const { labelIcon: t, ...r } = e, n = !!Ae(e.rules?.required), o = e.defaultValue ?? "", { field: a, fieldState: i } = Et({
    ...e,
    defaultValue: o
  });
  return /* @__PURE__ */ E(
    ie,
    {
      name: e.name,
      label: e.label,
      labelIcon: t,
      isRequired: n,
      error: i.error,
      children: [
        /* @__PURE__ */ s(
          vr,
          {
            isRequired: n,
            id: e.name,
            "data-testid": e.name,
            validated: i.error ? X.error : X.default,
            isDisabled: e.isDisabled,
            ...r,
            ...a
          }
        ),
        e.helperText && /* @__PURE__ */ s(ft, { children: /* @__PURE__ */ s(mt, { children: /* @__PURE__ */ s(yt, { children: e.helperText }) }) })
      ]
    }
  );
}, bo = ({
  id: e,
  name: t,
  label: r,
  options: n,
  controller: o,
  labelIcon: a,
  ...i
}) => {
  const {
    control: c,
    formState: { errors: l }
  } = Ve(), [d, p] = _(!1), u = Ae(o.rules?.required) === !0;
  return /* @__PURE__ */ s(
    ie,
    {
      name: t,
      label: r,
      isRequired: u,
      error: J(l, t),
      labelIcon: a,
      children: /* @__PURE__ */ s(
        ge,
        {
          ...o,
          name: t,
          control: c,
          render: ({ field: { onChange: y, value: f } }) => /* @__PURE__ */ s(
            $e,
            {
              ...i,
              onClick: () => p(!d),
              onOpenChange: () => p(!1),
              selected: Ce(n) ? n.filter(
                (g) => Array.isArray(f) ? f.includes(g.key) : f === g.key
              ).map((g) => g.value) : f,
              toggle: (g) => /* @__PURE__ */ s(
                ve,
                {
                  id: e || t.slice(t.lastIndexOf(".") + 1),
                  ref: g,
                  onClick: () => p(!d),
                  isExpanded: d,
                  isFullWidth: !0,
                  status: J(l, t) ? gt.danger : void 0,
                  "aria-label": "toggle",
                  children: Ce(n) ? n.find(
                    (k) => k.key === (Array.isArray(f) ? f[0] : f)
                  )?.value : f
                }
              ),
              onSelect: (g, k) => {
                const b = k?.toString();
                y(Array.isArray(f) ? [b] : b), p(!1);
              },
              isOpen: d,
              children: /* @__PURE__ */ s(je, { "data-testid": `select-${t}`, children: n.map((g) => /* @__PURE__ */ s(bt, { value: ne(g), children: kt(g) ? g : g.value }, ne(g))) })
            }
          )
        }
      )
    }
  );
}, Ke = (e) => kt(e) ? e : e.value, So = ({
  id: e,
  name: t,
  label: r,
  options: n,
  controller: o,
  labelIcon: a,
  placeholderText: i,
  onFilter: c,
  variant: l,
  ...d
}) => {
  const {
    control: p,
    formState: { errors: u }
  } = Ve(), [y, f] = _(!1), [g, k] = _(""), [b, S] = _(0), R = Z(), P = Ae(o.rules?.required) === !0, C = l === Ee.typeaheadMulti, w = n.filter(
    (m) => Ke(m).toLowerCase().startsWith(g.toLowerCase())
  ), I = H(
    () => w.map((m, A) => /* @__PURE__ */ s(
      bt,
      {
        value: ne(m),
        isFocused: b === A,
        children: Ke(m)
      },
      ne(m)
    )),
    [b, w]
  ), N = (m, A) => {
    const x = w[b];
    switch (f(!0), m.key) {
      case "Enter": {
        m.preventDefault(), k(C ? "" : Ke(x)), A.onChange(
          Array.isArray(A.value) ? [...A.value, ne(x)] : ne(x)
        ), f(!1), S(0);
        break;
      }
      case "Tab":
      case "Escape": {
        f(!1), A.onChange(void 0);
        break;
      }
      case "Backspace": {
        l === Ee.typeahead && A.onChange("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        m.preventDefault();
        let v = 0;
        m.key === "ArrowUp" && (b === 0 ? v = n.length - 1 : v = b - 1), m.key === "ArrowDown" && (b === n.length - 1 ? v = 0 : v = b + 1), S(v);
        break;
      }
    }
  };
  return /* @__PURE__ */ s(
    ie,
    {
      name: t,
      label: r,
      isRequired: P,
      error: J(u, t),
      labelIcon: a,
      children: /* @__PURE__ */ s(
        ge,
        {
          ...o,
          name: t,
          control: p,
          render: ({ field: m }) => /* @__PURE__ */ s(
            $e,
            {
              ...d,
              onOpenChange: () => f(!1),
              selected: Ce(n) ? n.filter(
                (A) => Array.isArray(m.value) ? m.value.includes(A.key) : m.value === A.key
              ).map((A) => A.value) : m.value,
              shouldFocusFirstItemOnOpen: !1,
              toggle: (A) => /* @__PURE__ */ s(
                ve,
                {
                  ref: A,
                  id: e || t.slice(t.lastIndexOf(".") + 1),
                  variant: "typeahead",
                  onClick: () => {
                    f(!y), R.current?.focus();
                  },
                  isExpanded: y,
                  isFullWidth: !0,
                  status: J(u, t) ? gt.danger : void 0,
                  children: /* @__PURE__ */ E(Xt, { isPlain: !0, children: [
                    /* @__PURE__ */ s(
                      Zt,
                      {
                        placeholder: i,
                        value: l === Ee.typeahead && m.value ? Ce(n) ? n.find(
                          (x) => x.key === (Array.isArray(m.value) ? m.value[0] : m.value)
                        )?.value : m.value : g,
                        onClick: () => f(!y),
                        onChange: (x, v) => {
                          k(v), c?.(v);
                        },
                        onKeyDown: (x) => N(x, m),
                        autoComplete: "off",
                        innerRef: R,
                        role: "combobox",
                        isExpanded: y,
                        "aria-controls": "select-typeahead-listbox",
                        children: l === Ee.typeaheadMulti && Array.isArray(m.value) && /* @__PURE__ */ s(St, { "aria-label": "Current selections", children: m.value.map(
                          (x, v) => /* @__PURE__ */ s(
                            wt,
                            {
                              onClick: (O) => {
                                O.stopPropagation(), m.onChange(
                                  m.value.filter(
                                    (M) => M !== ne(x)
                                  )
                                );
                              },
                              children: Ce(n) ? n.find((O) => x === O.key)?.value : Ke(x)
                            },
                            v
                          )
                        ) })
                      }
                    ),
                    /* @__PURE__ */ s(Qt, { children: (!!g || m.value) && /* @__PURE__ */ s(
                      L,
                      {
                        variant: "plain",
                        onClick: () => {
                          k(""), m.onChange(C ? [] : ""), R?.current?.focus();
                        },
                        "aria-label": "Clear input value",
                        children: /* @__PURE__ */ s(ir, { "aria-hidden": !0 })
                      }
                    ) })
                  ] })
                }
              ),
              onSelect: (A, x) => {
                A?.stopPropagation();
                const v = x?.toString();
                C && Array.isArray(m.value) ? m.value.includes(v) ? m.onChange(
                  m.value.filter((O) => O !== v)
                ) : m.onChange([...m.value, v]) : (m.onChange(Array.isArray(m.value) ? [v] : v), f(!1));
              },
              isOpen: y,
              children: /* @__PURE__ */ s(je, { children: I })
            }
          )
        }
      )
    }
  );
};
var Ee = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(Ee || {});
const Ce = (e) => typeof e[0] != "string", kt = (e) => typeof e == "string", ne = (e) => kt(e) ? e : e.key, wo = ({
  variant: e = "single",
  ...t
}) => e === "single" ? /* @__PURE__ */ s(bo, { ...t }) : /* @__PURE__ */ s(So, { ...t, variant: e }), Ta = ({
  labelOn: e,
  stringify: t,
  defaultValue: r,
  labelIcon: n,
  ...o
}) => {
  const i = r ?? (t ? "false" : !1), { control: c } = Ve();
  return /* @__PURE__ */ s(
    ie,
    {
      hasNoPaddingTop: !0,
      name: o.name,
      isRequired: o.rules?.required === !0,
      label: o.label,
      labelIcon: n,
      children: /* @__PURE__ */ s(
        ge,
        {
          control: c,
          name: o.name,
          defaultValue: i,
          render: ({ field: { onChange: l, value: d } }) => /* @__PURE__ */ s(
            Br,
            {
              ...o,
              id: o.name,
              "data-testid": o.name,
              label: e,
              isChecked: t ? d === "true" : d,
              isDisabled: o.isDisabled,
              onChange: (p, u) => {
                const y = t ? u.toString() : u;
                o.onChange?.(p, u), l(y);
              }
            }
          )
        }
      )
    }
  );
}, va = (e) => {
  const t = !!e.rules?.required, r = e.defaultValue ?? "", { field: n, fieldState: o } = Et({
    ...e,
    defaultValue: r
  });
  return /* @__PURE__ */ s(
    ie,
    {
      isRequired: t,
      label: e.label,
      labelIcon: e.labelIcon,
      name: e.name,
      error: o.error,
      children: /* @__PURE__ */ s(
        er,
        {
          isRequired: t,
          id: e.name,
          "data-testid": e.name,
          validated: o.error ? X.error : X.default,
          isDisabled: e.isDisabled,
          ...n
        }
      )
    }
  );
}, Ia = (e) => {
  const { labelIcon: t, helperText: r, ...n } = e, o = !!Ae(e.rules?.required), a = e.defaultValue ?? "", { field: i, fieldState: c } = Et({
    ...e,
    defaultValue: a
  });
  return /* @__PURE__ */ E(
    ie,
    {
      name: e.name,
      label: e.label,
      labelIcon: t,
      isRequired: o,
      error: c.error,
      children: [
        /* @__PURE__ */ s(
          Fe,
          {
            isRequired: o,
            id: e.name,
            "data-testid": e["data-testid"] || e.name,
            validated: c.error ? X.error : X.default,
            isDisabled: e.isDisabled,
            ...n,
            ...i
          }
        ),
        r && /* @__PURE__ */ s(ft, { children: /* @__PURE__ */ s(mt, { children: /* @__PURE__ */ s(yt, { children: r }) }) })
      ]
    }
  );
}, Eo = er, Aa = ({ icon: e }) => {
  const t = Co(e);
  return /* @__PURE__ */ s(ot, { size: "lg", children: /* @__PURE__ */ s(t, { alt: e }) });
};
function Co(e) {
  switch (e) {
    case "github":
      return jn;
    case "facebook":
      return $n;
    case "gitlab":
      return Fn;
    case "google":
      return Un;
    case "linkedin":
    case "linkedin-openid-connect":
      return Hn;
    case "openshift-v4":
      return Ln;
    case "stackoverflow":
      return Jn;
    case "twitter":
      return Mn;
    case "microsoft":
      return Wn;
    case "bitbucket":
      return Nn;
    case "instagram":
      return Kn;
    case "paypal":
      return Dn;
    default:
      return On;
  }
}
const To = "_title_180i0_2", vo = {
  title: To
}, Ir = ({
  id: e,
  title: t,
  headingLevel: r = "h1",
  size: n = "xl",
  ...o
}) => /* @__PURE__ */ s(
  qr,
  {
    headingLevel: r,
    size: n,
    className: vo.title,
    id: e,
    tabIndex: 0,
    ...o,
    children: t
  }
), Io = ({
  title: e,
  children: t,
  scrollId: r,
  className: n
}) => {
  const o = nr();
  return /* @__PURE__ */ E(Gr, { id: o, className: n, isFlat: !0, children: [
    /* @__PURE__ */ s(zr, { className: "kc-form-panel__header", children: /* @__PURE__ */ s(Yr, { tabIndex: 0, children: /* @__PURE__ */ s(Ir, { id: r, title: e }) }) }),
    /* @__PURE__ */ s(Xr, { className: "kc-form-panel__body", children: t })
  ] });
}, Ao = (e) => {
  const { title: t, children: r, scrollId: n, ...o } = e;
  return /* @__PURE__ */ s("section", { ...o, style: { marginTop: "var(--pf-v5-global--spacer--lg)" }, children: /* @__PURE__ */ E(q, { children: [
    /* @__PURE__ */ s(Ir, { id: n, title: t }),
    r
  ] }) });
}, _o = "_panel_1cdve_1", ko = "_sticky_1cdve_5", Ut = {
  panel: _o,
  sticky: ko
}, Ro = "kc-main-content-page-container", Ft = (e) => e.replace(/\s+/g, "-"), Po = ({
  label: e,
  sections: t,
  borders: r = !1,
  ...n
}) => {
  const o = H(
    () => t.filter(({ isHidden: a }) => !a),
    [t]
  );
  return /* @__PURE__ */ E(Zr, { hasGutter: !0, ...n, children: [
    /* @__PURE__ */ s(Nt, { md: 8, sm: 12, children: o.map(({ title: a, panel: i }) => {
      const c = Ft(a.toLowerCase());
      return /* @__PURE__ */ s(sr, { children: r ? /* @__PURE__ */ s(
        Io,
        {
          scrollId: c,
          title: a,
          className: Ut.panel,
          children: i
        }
      ) : /* @__PURE__ */ s(Ao, { scrollId: c, title: a, children: i }) }, a);
    }) }),
    /* @__PURE__ */ s(Nt, { md: 4, sm: 12, order: { default: "-1", md: "1" }, children: /* @__PURE__ */ s(Qr, { className: Ut.sticky, children: /* @__PURE__ */ s(
      en,
      {
        isVertical: !0,
        scrollableSelector: `#${Ro}`,
        label: e,
        offset: 100,
        children: o.map(({ title: a }) => {
          const i = Ft(a.toLowerCase());
          return (
            // note that JumpLinks currently does not work with spaces in the href
            /* @__PURE__ */ s(
              tn,
              {
                href: `#${i}`,
                "data-testid": `jump-link-${i}`,
                children: a
              },
              a
            )
          );
        })
      }
    ) }) })
  ] });
}, xo = (e, t, r) => (e.isValid || r) && (e.isDirty || t) && !e.isLoading && !e.isValidating && !e.isSubmitting, _a = ({
  formState: e,
  isDisabled: t = !1,
  allowInvalid: r = !1,
  allowNonDirty: n = !1,
  children: o,
  ...a
}) => /* @__PURE__ */ s(
  L,
  {
    variant: "primary",
    isDisabled: e && !xo(e, n, r) || t,
    ...a,
    type: "submit",
    children: o
  }
), Oo = (e) => {
  try {
    return new Intl.DisplayNames([e], { type: "language" }).of(e);
  } catch {
    return e;
  }
}, Do = ({
  t: e,
  form: t,
  supportedLocales: r,
  currentLocale: n
}) => {
  const o = H(
    () => r.map((a) => ({
      key: a,
      value: e(`locale_${a}`, Oo(a) ?? a)
    })).sort((a, i) => a.value.localeCompare(i.value, n)),
    [r, n, e]
  );
  return o.length ? /* @__PURE__ */ s(Yn, { ...t, children: /* @__PURE__ */ s(
    wo,
    {
      "data-testid": "locale-select",
      name: "attributes.locale",
      label: e("selectALocale"),
      controller: { defaultValue: "" },
      options: o,
      variant: o.length >= 10 ? "typeahead" : "single"
    }
  ) }) : null;
}, dt = (e) => e?.includes("${"), ut = (e) => e.substring(2, e.length - 1), ae = (e, t, r, n) => {
  const o = t || r, a = dt(o) ? ut(o) : o, i = n ? `${n}.${a}` : a;
  return e(i || "");
}, ht = (e, t) => ae(e, t.displayName, t.name), Ko = ["username", "firstName", "lastName", "email"], Ar = (e) => e && Ko.includes(e), Q = (e) => `${Ar(e) ? "" : "attributes."}${e?.replaceAll(
  ".",
  "🍺"
)}`, ka = (e) => e.replaceAll(".", "🍺"), Ra = (e) => e.replaceAll("🍺", ".");
function Pa(e, t, r) {
  (e.responseData.errors !== void 0 ? e.responseData.errors : [e.responseData]).forEach((n) => {
    const o = Object.assign(
      {},
      n.params?.map((a) => dt(a.toString()) ? r(ut(a)) : a)
    );
    t(Q(n.field), {
      message: r(
        dt(n.errorMessage) ? ut(n.errorMessage) : n.errorMessage,
        {
          ...o,
          defaultValue: n.errorMessage || n.field
        }
      ),
      type: "server"
    });
  });
}
function qe({
  required: e
}) {
  return e;
}
function xa(e) {
  if (typeof e != "object" || e === null || !("responseData" in e))
    return !1;
  const { responseData: t } = e;
  return $t(t) ? !0 : typeof t != "object" || t === null || !("errors" in t) || !Array.isArray(t.errors) ? !1 : t.errors.every($t);
}
function $t(e) {
  return !(typeof e != "object" || e === null || !("field" in e) || typeof e.field != "string" || !("errorMessage" in e) || typeof e.errorMessage != "string");
}
const _e = ({
  t: e,
  form: t,
  attribute: r,
  renderer: n,
  children: o
}) => {
  const a = ae(
    e,
    r.annotations?.inputHelperTextBefore
  ), {
    formState: { errors: i }
  } = t, c = n?.(r), l = J(i, Q(r.name));
  return /* @__PURE__ */ E(
    Yt,
    {
      label: ht(e, r) || "",
      fieldId: r.name,
      isRequired: qe(r),
      labelIcon: a ? /* @__PURE__ */ s(Tr, { helpText: a, fieldLabelId: r.name }) : void 0,
      children: [
        c ? /* @__PURE__ */ E(Ue, { children: [
          o,
          c
        ] }) : o,
        l && /* @__PURE__ */ s(
          Cr,
          {
            "data-testid": `${r.name}-helper`,
            message: l.message
          }
        )
      ]
    },
    r.name
  );
}, No = ({
  t: e,
  form: t,
  attribute: r,
  renderer: n,
  ...o
}) => /* @__PURE__ */ s(_e, { t: e, form: t, attribute: r, renderer: n, children: /* @__PURE__ */ s(
  Wo,
  {
    t: e,
    form: t,
    "aria-label": ht(e, r),
    name: Q(r.name),
    addButtonLabel: e("addMultivaluedLabel", {
      fieldLabel: ht(e, r)
    }),
    ...o
  }
) }), Wo = ({
  t: e,
  name: t,
  inputType: r,
  form: n,
  addButtonLabel: o,
  isDisabled: a = !1,
  defaultValue: i,
  id: c,
  ...l
}) => {
  const { register: d, setValue: p, control: u } = n, y = Xn({
    name: t,
    control: u,
    defaultValue: i || ""
  }), f = H(() => Array.isArray(y) && y.length !== 0 ? y : i || [""], [y]), g = (P) => {
    S([...f.slice(0, P), ...f.slice(P + 1)]);
  }, k = () => {
    S([...f, ""]);
  }, b = (P, C) => {
    S([...f.slice(0, P), C, ...f.slice(P + 1)]);
  }, S = (P) => {
    const C = P.flatMap((w) => w);
    p(t, C, {
      shouldDirty: !0
    });
  }, R = r.startsWith("html") ? r.substring(6) : "text";
  return ye(() => {
    d(t);
  }, [d]), /* @__PURE__ */ s("div", { id: c, children: f.map((P, C) => /* @__PURE__ */ E(sr, { children: [
    /* @__PURE__ */ E(Ue, { children: [
      /* @__PURE__ */ s(at, { isFill: !0, children: /* @__PURE__ */ s(
        Fe,
        {
          "data-testid": t + C,
          onChange: (w, I) => b(C, I),
          name: `${t}.${C}.value`,
          value: P,
          isDisabled: a,
          type: R,
          ...l
        }
      ) }),
      /* @__PURE__ */ s(at, { children: /* @__PURE__ */ s(
        L,
        {
          "data-testid": "remove" + C,
          variant: We.link,
          onClick: () => g(C),
          tabIndex: -1,
          "aria-label": e("remove"),
          isDisabled: f.length === 1 || a,
          children: /* @__PURE__ */ s(Vn, {})
        }
      ) })
    ] }),
    C === f.length - 1 && /* @__PURE__ */ E(
      L,
      {
        variant: We.link,
        onClick: k,
        tabIndex: -1,
        "aria-label": e("add"),
        "data-testid": "addValue",
        isDisabled: !P || a,
        children: [
          /* @__PURE__ */ s(cr, {}),
          " ",
          e(o || "add")
        ]
      }
    )
  ] }, C)) });
}, jt = (e) => {
  const { form: t, inputType: r, attribute: n } = e, o = qe(n), a = r.startsWith("multiselect"), i = a ? rn : nn, c = n.validators?.options?.options || [], l = n.annotations?.inputOptionLabels || {}, d = n.annotations?.inputOptionLabelsI18nPrefix;
  return /* @__PURE__ */ s(_e, { ...e, children: /* @__PURE__ */ s(
    ge,
    {
      name: Q(n.name),
      control: t.control,
      defaultValue: "",
      render: ({ field: p }) => /* @__PURE__ */ s(q, { children: c.map((u) => /* @__PURE__ */ s(
        i,
        {
          id: u,
          "data-testid": u,
          label: ae(e.t, l[u], u, d),
          value: u,
          isChecked: p.value.includes(u),
          onChange: () => {
            a ? p.value.includes(u) ? p.onChange(
              p.value.filter((y) => y !== u)
            ) : p.onChange([...p.value, u]) : p.onChange([u]);
          },
          readOnly: n.readOnly,
          isRequired: o
        },
        u
      )) })
    }
  ) });
}, Mo = ({
  toggleId: e,
  onToggle: t,
  onSelect: r,
  selections: n,
  isOpen: o,
  menuAppendTo: a,
  direction: i,
  width: c,
  maxHeight: l,
  toggleIcon: d,
  className: p,
  isDisabled: u,
  children: y,
  ...f
}) => {
  const [g, k] = _(!1), b = Z(), S = () => {
    k(!g), t(!g);
  }, R = () => a === "parent" && b.current?.parentElement || "inline", P = or.toArray(
    y
  );
  return /* @__PURE__ */ s(
    $e,
    {
      ref: b,
      maxMenuHeight: He(l),
      isScrollable: !0,
      popperProps: {
        appendTo: R(),
        direction: i,
        width: He(c)
      },
      ...f,
      onClick: S,
      onOpenChange: (C) => {
        C !== g && S();
      },
      selected: n,
      onSelect: (C, w) => {
        r?.(w || ""), S();
      },
      toggle: (C) => /* @__PURE__ */ s(
        ve,
        {
          id: e,
          ref: C,
          className: p,
          onClick: S,
          isExpanded: o,
          "aria-label": f["aria-label"],
          icon: d,
          isDisabled: u,
          isFullWidth: !0,
          children: P.find((w) => w.props.value === n)?.props.children || n || f["aria-label"]
        }
      ),
      isOpen: o,
      children: /* @__PURE__ */ s(je, { children: y })
    }
  );
}, Jo = ({
  toggleId: e,
  onSelect: t,
  onToggle: r,
  onFilter: n,
  variant: o,
  validated: a,
  placeholderText: i,
  maxHeight: c,
  width: l,
  toggleIcon: d,
  direction: p,
  selections: u,
  typeAheadAriaLabel: y,
  chipGroupComponent: f,
  chipGroupProps: g,
  footer: k,
  isDisabled: b,
  children: S,
  ...R
}) => {
  const [P, C] = _(""), [w, I] = _(0), N = Z(), m = or.toArray(
    S
  ), A = () => {
    r?.(!R.isOpen);
  }, x = (v) => {
    const O = m[w];
    switch (r?.(!0), v.key) {
      case "Enter": {
        v.preventDefault(), o !== Y.typeaheadMulti ? C(O.props.value) : C(""), t?.(O.props.value), r?.(!1), I(0);
        break;
      }
      case "Escape": {
        r?.(!1);
        break;
      }
      case "Backspace": {
        o === Y.typeahead && t?.("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        v.preventDefault();
        let M = 0;
        v.key === "ArrowUp" && (w === 0 ? M = m.length - 1 : M = w - 1), v.key === "ArrowDown" && (w === m.length - 1 ? M = 0 : M = w + 1), I(M);
        break;
      }
    }
  };
  return /* @__PURE__ */ E(
    $e,
    {
      ...R,
      onClick: A,
      onOpenChange: (v) => r?.(v),
      onSelect: (v, O) => {
        t?.(O || ""), C(""), n?.("");
      },
      maxMenuHeight: He(c),
      selected: u,
      popperProps: { direction: p, width: He(l) },
      toggle: (v) => /* @__PURE__ */ s(
        ve,
        {
          ref: v,
          id: e,
          variant: "typeahead",
          onClick: () => r?.(!0),
          icon: d,
          isDisabled: b,
          isExpanded: R.isOpen,
          isFullWidth: !0,
          status: a === "error" ? gt.danger : void 0,
          children: /* @__PURE__ */ E(Xt, { isPlain: !0, children: [
            /* @__PURE__ */ s(
              Zt,
              {
                placeholder: i,
                value: o === Y.typeahead && u ? u : P,
                onClick: A,
                onChange: (O, M) => {
                  C(M), n?.(M);
                },
                onKeyDown: (O) => x(O),
                autoComplete: "off",
                innerRef: N,
                role: "combobox",
                isExpanded: R.isOpen,
                selected: !0,
                "aria-controls": "select-typeahead-listbox",
                "aria-label": y,
                children: o === Y.typeaheadMulti && Array.isArray(u) && (f || /* @__PURE__ */ s(St, { ...g, children: u.map((O, M) => /* @__PURE__ */ s(
                  wt,
                  {
                    onClick: (Ge) => {
                      Ge.stopPropagation(), t?.(O);
                    },
                    children: O
                  },
                  M
                )) }))
              }
            ),
            /* @__PURE__ */ s(Qt, { children: !!P && /* @__PURE__ */ s(
              L,
              {
                variant: "plain",
                onClick: () => {
                  t?.(""), C(""), n?.(""), N?.current?.focus();
                },
                "aria-label": "Clear input value",
                children: /* @__PURE__ */ s(ir, { "aria-hidden": !0 })
              }
            ) })
          ] })
        }
      ),
      children: [
        /* @__PURE__ */ s(je, { children: S }),
        k && /* @__PURE__ */ s(sn, { children: k })
      ]
    }
  );
};
var Y = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(Y || {});
const He = (e) => typeof e == "number" ? e + "px" : e, Lo = ({
  variant: e = "single",
  ...t
}) => e === "single" ? /* @__PURE__ */ s(Mo, { ...t }) : /* @__PURE__ */ s(Jo, { ...t, variant: e }), Vt = (e) => {
  const { t, form: r, inputType: n, attribute: o } = e, [a, i] = _(!1), [c, l] = _(""), d = n === "multiselect", p = (b, S) => {
    d ? S.value.includes(b) ? S.onChange(S.value.filter((R) => R !== b)) : Array.isArray(S.value) ? S.onChange([...S.value, b]) : S.onChange([b]) : S.onChange(b === S.value ? "" : b);
  }, u = o.validators?.options?.options || [], y = o.annotations?.inputOptionLabels || {}, f = o.annotations?.inputOptionLabelsI18nPrefix, g = (b) => ae(e.t, y[b], b, f), k = (b) => u.filter(
    (S) => g(S).toLowerCase().includes(c.toLowerCase())
  ).map((S) => /* @__PURE__ */ s(
    bt,
    {
      selected: b === S,
      value: S,
      children: g(S)
    },
    S
  ));
  return /* @__PURE__ */ s(_e, { ...e, children: /* @__PURE__ */ s(
    ge,
    {
      name: Q(o.name),
      defaultValue: "",
      control: r.control,
      render: ({ field: b }) => /* @__PURE__ */ s(
        Lo,
        {
          toggleId: o.name,
          onToggle: (S) => i(S),
          onClear: () => p("", b),
          onSelect: (S) => {
            const R = S.toString();
            p(R, b), Array.isArray(b.value) || i(!1);
          },
          selections: d && Array.isArray(b.value) ? b.value.map((S) => g(S)) : g(b.value),
          variant: d ? Y.typeaheadMulti : u.length >= 10 ? Y.typeahead : Y.single,
          "aria-label": t("selectOne"),
          isOpen: a,
          isDisabled: o.readOnly,
          onFilter: (S) => (l(S), k(b.value)),
          children: k(b.value)
        }
      )
    }
  ) });
}, Ho = (e) => {
  const { form: t, attribute: r } = e, n = qe(r);
  return /* @__PURE__ */ s(_e, { ...e, children: /* @__PURE__ */ s(
    Eo,
    {
      id: r.name,
      "data-testid": r.name,
      ...t.register(Q(r.name)),
      cols: r.annotations?.inputTypeCols,
      rows: r.annotations?.inputTypeRows,
      readOnly: r.readOnly,
      isRequired: n
    }
  ) });
}, $ = (e) => {
  const { form: t, inputType: r, attribute: n } = e, o = qe(n), a = r.startsWith("html") ? r.substring(6) : "text";
  return /* @__PURE__ */ s(_e, { ...e, children: /* @__PURE__ */ s(
    Fe,
    {
      id: n.name,
      "data-testid": n.name,
      type: a,
      placeholder: n.readOnly ? "" : ae(
        e.t,
        n.annotations?.inputTypePlaceholder,
        n.name,
        n.annotations?.inputOptionLabelsI18nPrefix
      ),
      isDisabled: n.readOnly,
      isRequired: o,
      ...t.register(Q(n.name))
    }
  ) });
}, pt = {
  text: $,
  textarea: Ho,
  select: Vt,
  "select-radiobuttons": jt,
  multiselect: Vt,
  "multiselect-checkboxes": jt,
  "html5-email": $,
  "html5-tel": $,
  "html5-url": $,
  "html5-number": $,
  "html5-range": $,
  "html5-datetime-local": $,
  "html5-date": $,
  "html5-month": $,
  "html5-time": $,
  "multi-input": No
}, Oa = ({
  t: e,
  form: t,
  userProfileMetadata: r,
  supportedLocales: n,
  currentLocale: o,
  hideReadOnly: a = !1,
  renderer: i
}) => {
  const c = H(() => {
    if (!r.attributes)
      return [];
    const l = a ? r.attributes.filter(({ readOnly: d }) => !d) : r.attributes;
    return [
      // Insert an empty group for attributes without a group.
      { name: void 0 },
      ...r.groups ?? []
    ].map((d) => ({
      group: d,
      attributes: l.filter(
        (p) => p.group === d.name
      )
    }));
  }, [
    a,
    r.groups,
    r.attributes
  ]);
  return c.length === 0 ? null : /* @__PURE__ */ s(
    Po,
    {
      label: e("jumpToSection"),
      sections: c.filter((l) => l.attributes.length > 0).map(({ group: l, attributes: d }) => ({
        title: ae(e, l.displayHeader, l.name) || e("general"),
        panel: /* @__PURE__ */ E("div", { className: "pf-v5-c-form", children: [
          l.displayDescription && /* @__PURE__ */ s(st, { className: "pf-v5-u-pb-lg", children: ae(e, l.displayDescription, "") }),
          d.map((p) => /* @__PURE__ */ s(
            Uo,
            {
              t: e,
              form: t,
              supportedLocales: n,
              currentLocale: o,
              renderer: i,
              attribute: p
            },
            p.name
          ))
        ] })
      }))
    }
  );
}, Uo = ({
  t: e,
  form: t,
  renderer: r,
  supportedLocales: n,
  currentLocale: o,
  attribute: a
}) => {
  const i = t.watch(
    Q(a.name)
  ), c = H(() => $o(a), [a]), l = a.multivalued || Vo(i) && a.annotations?.inputType === void 0 ? pt["multi-input"] : pt[c];
  return a.name === "locale" ? /* @__PURE__ */ s(
    Do,
    {
      form: t,
      supportedLocales: n,
      currentLocale: o,
      t: e,
      attribute: a
    }
  ) : /* @__PURE__ */ s(
    l,
    {
      t: e,
      form: t,
      inputType: c,
      attribute: a,
      renderer: r
    }
  );
}, Fo = "text";
function $o(e) {
  if (Ar(e.name))
    return "text";
  const t = e.annotations?.inputType;
  return jo(t) ? t : Fo;
}
const jo = (e) => typeof e == "string" && e in pt, Vo = (e) => Array.isArray(e) && e.length > 1, Bo = ({
  className: e = "",
  border: t,
  size: r = "md"
}) => /* @__PURE__ */ E(
  "svg",
  {
    className: es(
      xe.avatar,
      xe.modifiers[r],
      t === "light" && xe.modifiers.light,
      t === "dark" && xe.modifiers.dark,
      e
    ),
    enableBackground: "new 0 0 36 36",
    version: "1.1",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ s(
        "circle",
        {
          style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
          cx: "18",
          cy: "18.5",
          r: "18"
        }
      ),
      /* @__PURE__ */ s("defs", { children: /* @__PURE__ */ s(
        "filter",
        {
          id: "b",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          filterUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ s("feColorMatrix", { values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" })
        }
      ) }),
      /* @__PURE__ */ s(
        "mask",
        {
          id: "a",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ s("g", { style: { filter: 'url("#b")' }, children: /* @__PURE__ */ s(
            "circle",
            {
              style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
              cx: "18",
              cy: "18.5",
              r: "18"
            }
          ) })
        }
      ),
      /* @__PURE__ */ s("g", { style: { filter: 'url("#a")' }, children: /* @__PURE__ */ E("g", { transform: "translate(5.04 6.88)", children: [
        /* @__PURE__ */ s(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m22.6 18.1c-1.1-1.4-2.3-2.2-3.5-2.6s-1.8-0.6-6.3-0.6-6.1 0.7-6.1 0.7 0 0 0 0c-1.2 0.4-2.4 1.2-3.4 2.6-2.3 2.8-3.2 12.3-3.2 14.8 0 3.2 0.4 12.3 0.6 15.4 0 0-0.4 5.5 4 5.5l-0.3-6.3-0.4-3.5 0.2-0.9c0.9 0.4 3.6 1.2 8.6 1.2 5.3 0 8-0.9 8.8-1.3l0.2 1-0.2 3.6-0.3 6.3c3 0.1 3.7-3 3.8-4.4s0.6-12.6 0.6-16.5c0.1-2.6-0.8-12.1-3.1-15z"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m22.5 26c-0.1-2.1-1.5-2.8-4.8-2.8l2.2 9.6s1.8-1.7 3-1.8c0 0-0.4-4.6-0.4-5z"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m12.7 13.2c-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4 6.4 2.9 6.4 6.4-2.8 6.4-6.4 6.4z"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            style: {
              opacity: 0.08,
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#231F20"
            },
            d: "m9.4 6.8c0-3 2.1-5.5 4.9-6.3-0.5-0.1-1-0.2-1.6-0.2-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4c0.6 0 1.1-0.1 1.6-0.2-2.8-0.6-4.9-3.1-4.9-6.1z"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m8.3 22.4c-2 0.4-2.9 1.4-3.1 3.5l-0.6 18.6s1.7 0.7 3.6 0.9l0.1-23z"
          }
        )
      ] }) })
    ]
  }
), Bt = ({
  isKebab: e = !1,
  title: t,
  dropDownItems: r,
  ...n
}) => {
  const [o, a] = _(!1);
  return /* @__PURE__ */ s(
    on,
    {
      ...n,
      popperProps: {
        position: "right"
      },
      onOpenChange: (i) => a(i),
      toggle: (i) => /* @__PURE__ */ s(
        ve,
        {
          "data-testid": `${n["data-testid"]}-toggle`,
          ref: i,
          onClick: () => a(!o),
          isExpanded: o,
          variant: e ? "plain" : "default",
          children: e ? /* @__PURE__ */ s(Bn, {}) : t
        }
      ),
      isOpen: o,
      children: /* @__PURE__ */ s(an, { children: r })
    }
  );
};
function qo(e, t) {
  if (!e)
    return t("unknownUser");
  const r = e.given_name, n = e.family_name, o = e.preferred_username;
  return r && n ? t("fullName", { givenName: r, familyName: n }) : r || n || o || t("unknownUser");
}
const Da = ({
  keycloak: e,
  brand: { src: t, alt: r, className: n, ...o },
  avatar: a,
  features: {
    hasLogout: i = !0,
    hasManageAccount: c = !0,
    hasUsername: l = !0
  } = {},
  kebabDropdownItems: d,
  dropdownItems: p = [],
  toolbarItems: u,
  ...y
}) => {
  const { t: f } = U(), g = [];
  c && g.push(
    /* @__PURE__ */ s(
      Wt,
      {
        onClick: () => e.accountManagement(),
        children: f("manageAccount")
      },
      "manageAccount"
    )
  ), i && g.push(
    /* @__PURE__ */ s(Wt, { onClick: () => e.logout(), children: f("signOut") }, "signOut")
  );
  const k = e.idTokenParsed?.picture;
  return /* @__PURE__ */ E(cn, { ...y, children: [
    /* @__PURE__ */ s(ln, { children: /* @__PURE__ */ s(dn, { variant: "plain", "aria-label": f("navigation"), children: /* @__PURE__ */ s(qn, {}) }) }),
    /* @__PURE__ */ s(un, { ...o, children: /* @__PURE__ */ s("img", { src: t, alt: r, className: n }) }),
    /* @__PURE__ */ s(hn, { children: /* @__PURE__ */ s(Ne, { children: /* @__PURE__ */ E(it, { children: [
      u?.map((b, S) => /* @__PURE__ */ s(B, { align: { default: "alignRight" }, children: b }, S)),
      /* @__PURE__ */ s(
        B,
        {
          visibility: {
            default: "hidden",
            md: "visible"
          },
          children: /* @__PURE__ */ s(
            Bt,
            {
              "data-testid": "options",
              dropDownItems: [...p, g],
              title: l ? qo(e.idTokenParsed, f) : void 0
            }
          )
        }
      ),
      /* @__PURE__ */ s(
        B,
        {
          align: { default: "alignLeft" },
          visibility: {
            md: "hidden"
          },
          children: /* @__PURE__ */ s(
            Bt,
            {
              "data-testid": "options-kebab",
              isKebab: !0,
              dropDownItems: [
                ...d || p,
                g
              ]
            }
          )
        }
      ),
      /* @__PURE__ */ s(
        B,
        {
          variant: "overflow-menu",
          align: { default: "alignRight" },
          className: "pf-v5-u-m-0-on-lg",
          children: k || a?.src ? /* @__PURE__ */ s(pn, { src: k, alt: f("avatar"), ...a }) : /* @__PURE__ */ s(Bo, { ...a })
        }
      )
    ] }) }) })
  ] });
}, _r = Ct("ErrorBoundaryContext", void 0), kr = () => Tt(_r);
class Ka extends An {
  state = {};
  static getDerivedStateFromError = (t) => ({ error: t });
  showBoundary = (t) => {
    this.setState({ error: t });
  };
  render() {
    return /* @__PURE__ */ s(
      _r.Provider,
      {
        value: { error: this.state.error, showBoundary: this.showBoundary },
        children: this.props.children
      }
    );
  }
}
const Na = ({ children: e, fallback: t }) => {
  const { error: r } = kr();
  return r ? /* @__PURE__ */ s(t, { error: r }) : e;
};
function Go(e, t, r) {
  const { showBoundary: n } = kr();
  ye(() => {
    const o = new AbortController(), { signal: a } = o;
    return e().then((i) => {
      a.aborted || t(i);
    }).catch((i) => {
      console.error(i), a.aborted || n(i);
    }), () => o.abort();
  }, r);
}
const zo = () => {
  const { t: e } = U();
  return /* @__PURE__ */ s(fn, { children: /* @__PURE__ */ s(mn, { "aria-label": e("spinnerLoading") }) });
}, Yo = ({
  message: e,
  instructions: t,
  onPrimaryAction: r,
  hasIcon: n = !0,
  isSearchVariant: o,
  primaryActionText: a,
  secondaryActions: i,
  icon: c,
  isDisabled: l = !1
}) => /* @__PURE__ */ E(yn, { "data-testid": "empty-state", variant: "lg", children: [
  n && o ? /* @__PURE__ */ s(Mt, { icon: Gn }) : n && /* @__PURE__ */ s(Mt, { icon: c || cr }),
  /* @__PURE__ */ s(gn, { titleText: e, headingLevel: "h1" }),
  /* @__PURE__ */ s(bn, { children: t }),
  /* @__PURE__ */ E(Sn, { children: [
    a && /* @__PURE__ */ s(
      L,
      {
        "data-testid": `${e.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: "primary",
        onClick: r,
        isDisabled: l,
        children: a
      }
    ),
    i && /* @__PURE__ */ s(wn, { children: i.map((d) => /* @__PURE__ */ s(
      L,
      {
        "data-testid": `${d.text.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: d.type || We.secondary,
        onClick: d.onClick,
        isDisabled: l,
        children: d.text
      },
      d.text
    )) })
  ] })
] }), Xo = ({
  toolbarItem: e,
  subToolbar: t,
  toolbarItemFooter: r,
  children: n,
  searchTypeComponent: o,
  inputGroupName: a,
  inputGroupPlaceholder: i,
  inputGroupOnEnter: c
}) => {
  const { t: l } = U(), [d, p] = _(""), u = (f) => {
    p(f.trim()), c?.(f.trim());
  }, y = (f) => {
    f.key === "Enter" && u(d);
  };
  return /* @__PURE__ */ E(q, { children: [
    /* @__PURE__ */ s(Ne, { children: /* @__PURE__ */ E(it, { children: [
      a && /* @__PURE__ */ s(B, { children: /* @__PURE__ */ E(Ue, { "data-testid": a, children: [
        o,
        i && /* @__PURE__ */ s(
          En,
          {
            "data-testid": "table-search-input",
            placeholder: i,
            "aria-label": l("search"),
            value: d,
            onChange: (f, g) => {
              p(g);
            },
            onSearch: () => u(d),
            onKeyDown: y,
            onClear: () => u("")
          }
        )
      ] }) }),
      e
    ] }) }),
    t && /* @__PURE__ */ s(Ne, { children: /* @__PURE__ */ s(it, { children: t }) }),
    /* @__PURE__ */ s(Cn, {}),
    n,
    /* @__PURE__ */ s(Ne, { children: r })
  ] });
}, qt = ({
  id: e,
  variant: t = "top",
  count: r,
  first: n,
  max: o,
  onNextClick: a,
  onPreviousClick: i,
  onPerPageSelect: c
}) => {
  const { t: l } = U(), d = Math.round(n / o);
  return /* @__PURE__ */ s(
    Tn,
    {
      widgetId: e,
      titles: {
        paginationAriaLabel: `${l("pagination")} ${t} `
      },
      isCompact: !0,
      toggleTemplate: ({
        firstIndex: p,
        lastIndex: u
      }) => /* @__PURE__ */ E("b", { children: [
        p,
        " - ",
        u
      ] }),
      itemCount: r + d * o,
      page: d + 1,
      perPage: o,
      onNextClick: (p, u) => a((u - 1) * o),
      onPreviousClick: (p, u) => i((u - 1) * o),
      onPerPageSelect: (p, u, y) => c(y - 1, u),
      variant: t
    }
  );
}, Zo = ({
  count: e,
  searchTypeComponent: t,
  toolbarItem: r,
  subToolbar: n,
  children: o,
  inputGroupName: a,
  inputGroupPlaceholder: i,
  inputGroupOnEnter: c,
  ...l
}) => /* @__PURE__ */ s(
  Xo,
  {
    searchTypeComponent: t,
    toolbarItem: /* @__PURE__ */ E(q, { children: [
      r,
      /* @__PURE__ */ s(B, { variant: "pagination", children: /* @__PURE__ */ s(qt, { count: e, ...l }) })
    ] }),
    subToolbar: n,
    toolbarItemFooter: e !== 0 ? /* @__PURE__ */ s(B, { variant: "pagination", children: /* @__PURE__ */ s(qt, { count: e, variant: "bottom", ...l }) }) : null,
    inputGroupName: a,
    inputGroupPlaceholder: i,
    inputGroupOnEnter: c,
    children: o
  }
), Rr = (e) => !!e && e.title !== void 0, Gt = ({
  row: e,
  index: t,
  actions: r,
  actionResolver: n
}) => /* @__PURE__ */ E(q, { children: [
  e.cells.map((o, a) => /* @__PURE__ */ s(fe, { children: Rr(o) ? o.title : o }, `cell-${a}`)),
  (r || n) && /* @__PURE__ */ s(fe, { isActionCell: !0, children: /* @__PURE__ */ s(
    os,
    {
      items: r || n?.(e, {}),
      extraData: { rowIndex: t }
    }
  ) })
] }), Qo = ({ row: e }) => e.cells.map((t, r) => /* @__PURE__ */ s("div", { children: Rr(t) ? t.title : t }, `cell-${r}`));
function ea({
  columns: e,
  rows: t,
  actions: r,
  actionResolver: n,
  ariaLabelKey: o,
  selected: a,
  onSelect: i,
  onCollapse: c,
  canSelectAll: l,
  canSelect: d,
  isNotCompact: p,
  isRadio: u,
  ...y
}) {
  const { t: f } = U(), [g, k] = _(a || []), [b, S] = _([]), R = H(
    () => Zn(
      g,
      t.map((w) => w.data),
      "id"
    ),
    [g, t]
  );
  ye(() => {
    if (l) {
      const w = document.getElementsByName("check-all").item(0);
      if (w) {
        const I = w;
        I.indeterminate = R.length < t.length && R.length > 0;
      }
    }
  }, [g, l, t]);
  const P = (w) => {
    k(w), i?.(w);
  }, C = (w, I) => {
    if (w === -1) {
      const N = R.map((m) => J(m, "id"));
      P(
        I ? [...g, ...t.map((m) => m.data)] : g.filter(
          (m) => !N.includes(J(m, "id"))
        )
      );
    } else
      P(I ? [...g, t[w].data] : g.filter(
        (N) => J(N, "id") !== t[w].data.id
      ));
  };
  return /* @__PURE__ */ E(
    ts,
    {
      ...y,
      variant: p ? void 0 : rs.compact,
      "aria-label": f(o),
      children: [
        /* @__PURE__ */ s(ns, { children: /* @__PURE__ */ E(Oe, { children: [
          c && /* @__PURE__ */ s(Ze, { screenReaderText: f("expandRow") }),
          l && /* @__PURE__ */ s(
            Ze,
            {
              screenReaderText: f("selectAll"),
              select: u ? void 0 : {
                onSelect: (w, I) => {
                  C(-1, I);
                },
                isSelected: R.length === t.length
              }
            }
          ),
          e.map((w) => /* @__PURE__ */ s(
            Ze,
            {
              screenReaderText: f("expandRow"),
              className: w.transforms?.[0]().className,
              children: f(w.displayKey || w.name)
            },
            w.displayKey || w.name
          ))
        ] }) }),
        c ? t.map((w, I) => /* @__PURE__ */ s(Lt, { children: I % 2 === 0 ? /* @__PURE__ */ E(Oe, { children: [
          /* @__PURE__ */ s(
            fe,
            {
              expand: {
                isExpanded: !!b[I],
                rowIndex: I,
                expandId: `${I}`,
                onToggle: (N, m, A) => {
                  c(A, m);
                  const x = [...b];
                  x[I] = A, S(x);
                }
              }
            }
          ),
          /* @__PURE__ */ s(
            Gt,
            {
              row: w,
              index: I,
              actions: r,
              actionResolver: n
            }
          )
        ] }) : /* @__PURE__ */ E(Oe, { isExpanded: !!b[I - 1], children: [
          /* @__PURE__ */ s(fe, {}),
          /* @__PURE__ */ s(fe, { colSpan: e.length, children: /* @__PURE__ */ s(ss, { children: /* @__PURE__ */ s(Qo, { row: w }) }) })
        ] }) }, I)) : /* @__PURE__ */ s(Lt, { children: t.map((w, I) => /* @__PURE__ */ E(Oe, { isExpanded: b[I], children: [
          d && /* @__PURE__ */ s(
            fe,
            {
              select: {
                rowIndex: I,
                onSelect: (N, m, A) => {
                  C(A, m);
                },
                isSelected: !!g.find(
                  (N) => J(N, "id") === w.data.id
                ),
                variant: u ? "radio" : "checkbox"
              }
            }
          ),
          /* @__PURE__ */ s(
            Gt,
            {
              row: w,
              index: I,
              actions: r,
              actionResolver: n
            }
          )
        ] }, I)) })
      ]
    }
  );
}
function ta({
  ariaLabelKey: e,
  searchPlaceholderKey: t,
  isPaginated: r = !1,
  onSelect: n,
  canSelectAll: o = !1,
  isNotCompact: a,
  isRadio: i,
  detailColumns: c,
  isRowDisabled: l,
  loader: d,
  columns: p,
  actions: u,
  actionResolver: y,
  searchTypeComponent: f,
  toolbarItem: g,
  subToolbar: k,
  emptyState: b,
  icon: S,
  isSearching: R = !1,
  ...P
}) {
  const { t: C } = U(), [w, I] = _([]), [N, m] = _(), [A, x] = _(), [v, O] = _(!1), [M, Ge] = ur(
    localStorage,
    "pageSize",
    10
  ), [G, Pr] = _(M), [j, be] = _(0), [z, ze] = _(""), Rt = Z(), [ke, xr] = _(0), Pt = Z(), xt = () => xr(ke + 1), Or = nr(), Ot = (T, D) => T.map((K) => {
    if ("cellFormatters" in K) {
      const ee = J(D, K.name);
      return K.cellFormatters?.reduce((Se, Pe) => Pe(Se), ee);
    }
    if (K.cellRenderer) {
      const ee = K.cellRenderer;
      return { title: /* @__PURE__ */ s(ee, { ...D }) };
    }
    return J(D, K.name);
  }), Dt = (T) => {
    const D = (K) => c?.[0]?.enabled?.(K);
    return T.map((K, ee) => {
      const Se = l ? l(K) : !1, Pe = [
        {
          data: K,
          disableSelection: Se,
          disableActions: Se,
          selected: !!w.find((Mr) => J(Mr, "id") === J(K, "id")),
          isOpen: D(K) ? !1 : void 0,
          cells: Ot(p, K)
        }
      ];
      return c && Pe.push({
        parent: ee * 2,
        cells: D(K) ? Ot(c, K) : []
      }), Pe;
    }).flat();
  }, Ye = (T) => ["string", "number"].includes(typeof T) ? T.toString() : T instanceof Array ? T.map(Ye).join("") : typeof T == "object" ? Ye(
    _n(T.title) ? T.title.props : Object.values(T)
  ) : "", Kt = H(
    () => z === "" || r ? void 0 : Dt(A || []).filter(
      (T) => T.cells.some(
        (D) => D && Ye(D).toLowerCase().includes(z.toLowerCase())
      )
    ).slice(j, j + G + 1),
    [z, j, G]
  );
  Go(
    async () => {
      O(!0);
      const T = Rt.current === "" && z !== "";
      return T && be(0), Rt.current = z, typeof d == "function" ? ke === Pt.current && A ? A : await d(T ? 0 : j, G + 1, z) : d;
    },
    (T) => {
      Pt.current = ke, r || (x(T), T.length > j ? T = T.slice(j, j + G + 1) : be(0));
      const D = Dt(T);
      m(D), O(!1);
    },
    [
      ke,
      j,
      G,
      z,
      typeof d != "function" ? d : void 0
    ]
  );
  const Dr = () => u && Qn(u).map((T, D) => (delete T.onRowClick, T.onClick = async (K, ee) => {
    await u[D].onRowClick(
      (Kt || N)[ee].data
    ) && (r || ze(""), xt());
  }, T)), Kr = (T, D) => {
    ce[D].isOpen = T, m([...ce]);
  }, ce = Kt || N, Re = !ce, Xe = z !== "" || R, Nr = c ? G * 2 : G, Wr = c ? (ce?.length || 0) / 2 : ce?.length || 0;
  return /* @__PURE__ */ E(q, { children: [
    (v || !Re || Xe) && /* @__PURE__ */ E(
      Zo,
      {
        id: Or,
        count: Wr,
        first: j,
        max: G,
        onNextClick: be,
        onPreviousClick: be,
        onPerPageSelect: (T, D) => {
          be(T), Pr(D), Ge(D);
        },
        inputGroupName: t ? `${e}input` : void 0,
        inputGroupOnEnter: ze,
        inputGroupPlaceholder: C(t || ""),
        searchTypeComponent: f,
        toolbarItem: /* @__PURE__ */ E(q, { children: [
          g,
          " ",
          /* @__PURE__ */ s(B, { variant: "separator" }),
          " ",
          /* @__PURE__ */ s(B, { children: /* @__PURE__ */ E(L, { variant: "link", onClick: xt, children: [
            /* @__PURE__ */ s(zn, {}),
            " ",
            C("refresh")
          ] }) })
        ] }),
        subToolbar: k,
        children: [
          !v && !Re && /* @__PURE__ */ s(
            ea,
            {
              ...P,
              canSelectAll: o,
              canSelect: !!n,
              selected: w,
              onSelect: (T) => {
                I(T), n?.(T);
              },
              onCollapse: c ? Kr : void 0,
              actions: Dr(),
              actionResolver: y,
              rows: ce.slice(0, Nr),
              columns: p,
              isNotCompact: a,
              isRadio: i,
              ariaLabelKey: e
            }
          ),
          !v && Re && Xe && /* @__PURE__ */ s(
            Yo,
            {
              hasIcon: !0,
              icon: S,
              isSearchVariant: !0,
              message: C("noSearchResults"),
              instructions: C("noSearchResultsInstructions"),
              secondaryActions: R ? [] : [
                {
                  text: C("clearAllFilters"),
                  onClick: () => ze(""),
                  type: We.link
                }
              ]
            }
          ),
          v && /* @__PURE__ */ s(zo, {})
        ]
      }
    ),
    !v && Re && !Xe && b
  ] });
}
const ra = ({ link: e, organization: t }) => {
  const { t: r } = U();
  return /* @__PURE__ */ s(as, { wrapModifier: "truncate", children: /* @__PURE__ */ E(e, { organization: t, children: [
    t.name,
    !t.enabled && /* @__PURE__ */ s(
      vn,
      {
        isRead: !0,
        className: "pf-v5-u-ml-sm",
        children: r("disabled")
      },
      `${t.id}-disabled`
    )
  ] }) });
}, na = (e) => {
  const { t } = U();
  return /* @__PURE__ */ s(
    St,
    {
      numChips: 2,
      expandedText: t("hide"),
      collapsedText: t("showRemaining"),
      children: e.domains?.map((r) => {
        const n = typeof r == "string" ? r : r.name;
        return /* @__PURE__ */ s(wt, { isReadOnly: !0, children: n }, n);
      })
    }
  );
}, Wa = ({
  loader: e,
  toolbarItem: t,
  isPaginated: r = !1,
  isSearching: n = !1,
  onSelect: o,
  onDelete: a,
  deleteLabel: i = "delete",
  link: c,
  children: l
}) => {
  const { t: d } = U();
  return /* @__PURE__ */ s(
    ta,
    {
      loader: e,
      isPaginated: r,
      isSearching: n,
      ariaLabelKey: "organizationList",
      toolbarItem: t,
      onSelect: o,
      canSelectAll: o !== void 0,
      actions: a ? [
        {
          title: d(i),
          onRowClick: a
        }
      ] : void 0,
      columns: [
        {
          name: "name",
          displayKey: "name",
          cellRenderer: (p) => /* @__PURE__ */ s(ra, { link: c, organization: p })
        },
        {
          name: "domains",
          displayKey: "domains",
          cellRenderer: na
        },
        {
          name: "description",
          displayKey: "description"
        },
        {
          name: "membershipType",
          displayKey: "membershipType"
        }
      ],
      emptyState: l
    }
  );
};
export {
  ys as AlertProvider,
  wa as ContinueCancelModal,
  Na as ErrorBoundaryFallback,
  Ka as ErrorBoundaryProvider,
  gs as ErrorPage,
  Cr as FormErrorText,
  Io as FormPanel,
  _a as FormSubmitButton,
  Es as Help,
  Tr as HelpItem,
  Aa as IconMapper,
  ta as KeycloakDataTable,
  Da as KeycloakMasthead,
  ba as KeycloakProvider,
  Lo as KeycloakSelect,
  zo as KeycloakSpinner,
  Eo as KeycloakTextArea,
  Yo as ListEmptyState,
  Ea as NumberControl,
  Wa as OrganizationTable,
  Zo as PaginatingTableToolbar,
  Ca as PasswordControl,
  vr as PasswordInput,
  Po as ScrollForm,
  wo as SelectControl,
  Ee as SelectVariant,
  Cs as Spinner,
  Ta as SwitchControl,
  Xo as TableToolbar,
  va as TextAreaControl,
  Ia as TextControl,
  Oa as UserProfileFields,
  ka as beerify,
  Ct as createNamedContext,
  Ra as debeerify,
  us as generateId,
  ls as getErrorDescription,
  cs as getErrorMessage,
  Sa as getInjectedEnvironment,
  lr as getNetworkErrorDescription,
  ds as getNetworkErrorMessage,
  hs as isDefined,
  xa as isUserProfileError,
  ae as label,
  Ro as mainPageContentId,
  Pa as setUserProfileServerError,
  ya as useAlerts,
  ga as useEnvironment,
  kr as useErrorBoundary,
  Go as useFetch,
  ws as useHelp,
  Tt as useRequiredContext,
  ps as useSetTimeout,
  ur as useStoredState
};
